{
  "admin.alertsScreen.waGroup.title": {
    "defaultMessage": "Groupe WhatsApp pour les alertes"
  },
  "admin.dashboard.alertsBody": {
    "defaultMessage": "Configurer les notifications de surveillance"
  },
  "admin.dashboard.alertsBtnText": {
    "defaultMessage": "Gérer les alertes"
  },
  "admin.dashboard.alertsTitle": {
    "defaultMessage": "Alertes"
  },
  "admin.dashboard.btnLink": {
    "defaultMessage": "Obtenir le lien d'invitation du groupe"
  },
  "admin.dashboard.contentAiBody": {
    "defaultMessage": "Gérer la configuration Content AI"
  },
  "admin.dashboard.contentAiBtnText": {
    "defaultMessage": "Configurer"
  },
  "admin.dashboard.copyLink": {
    "defaultMessage": "Copier l'URL du lien"
  },
  "admin.dashboard.coreAdministrationTitle": {
    "defaultMessage": "Administration principale"
  },
  "admin.dashboard.featureConfigurationTitle": {
    "defaultMessage": "Configuration des fonctionnalités"
  },
  "admin.dashboard.fragments": {
    "defaultMessage": "Fragments"
  },
  "admin.dashboard.fragmentsBody": {
    "defaultMessage": "Gérer la configuration des fragments"
  },
  "admin.dashboard.fragmentsBtnText": {
    "defaultMessage": "Configurer"
  },
  "admin.dashboard.groupsBtnText": {
    "defaultMessage": "Gérer les groupes"
  },
  "admin.dashboard.socialIntegrationsTitle": {
    "defaultMessage": "Intégration avec les plateformes"
  },
  "admin.dashboard.stationsBody": {
    "defaultMessage": "Il y a {countBold} {count, plural, one {station enregistrée} other {stations enregistrées} }"
  },
  "admin.dashboard.stationsBtnText": {
    "defaultMessage": "Gérer les stations"
  },
  "admin.dashboard.stationsTitle": {
    "defaultMessage": "Stations"
  },
  "admin.dashboard.title": {
    "defaultMessage": "Administration"
  },
  "admin.dashboard.usersBody": {
    "defaultMessage": "Il y a {countBold} {count, plural, one {utilisateur enregistré} other {utilisateurs enregistrés} }"
  },
  "admin.dashboard.usersBtnText": {
    "defaultMessage": "Gérer les utilisateurs"
  },
  "admin.dashboard.usersTitle": {
    "defaultMessage": "Utilisateurs et groupes"
  },
  "admin.dashboard.videoAnalysisBody": {
    "defaultMessage": "Configurer l'analyse automatique vidéo"
  },
  "admin.dashboard.videoAnalysisBtnText": {
    "defaultMessage": "Configurer"
  },
  "admin.dashboard.videoAnalysisTitle": {
    "defaultMessage": "Analyse vidéo"
  },
  "admin.dashboard.youtubeBtnText": {
    "defaultMessage": "Configurer"
  },
  "admin.fragments.addNewFooter": {
    "defaultMessage": "Ajouter un nouveau pied de page"
  },
  "admin.fragments.configUpdated": {
    "defaultMessage": "Configuration des fragments pour {stationName} mise à jour"
  },
  "admin.fragments.footers": {
    "defaultMessage": "Pieds de page dans la description"
  },
  "admin.fragments.fragmentsConfigUpdated": {
    "defaultMessage": "Configuration des fragments pour {stationName} mise à jour"
  },
  "admin.fragments.newFooterName": {
    "defaultMessage": "Nouveau pied de page"
  },
  "admin.fragments.noFooters": {
    "defaultMessage": "Aucun pied de page enregistré"
  },
  "admin.fragments.registeredFootersTitle": {
    "defaultMessage": "Pieds de page enregistrés"
  },
  "admin.fragments.tagGroups": {
    "defaultMessage": "Groupes de tags"
  },
  "admin.fragments.title": {
    "defaultMessage": "Fragments"
  },
  "admin.fragments.twoDefaultsNotAllowed": {
    "defaultMessage": "Il ne peut pas y avoir deux pieds de page définis par défaut"
  },
  "admin.fragments.useAsDefault": {
    "defaultMessage": "Utiliser par défaut"
  },
  "admin.fragments.watermark": {
    "defaultMessage": "Filigrane média"
  },
  "admin.fragments.watermark.active": {
    "defaultMessage": "Actif"
  },
  "admin.fragments.watermark.configTitle": {
    "defaultMessage": "Configuration"
  },
  "admin.fragments.watermark.imageTitle": {
    "defaultMessage": "Image"
  },
  "admin.fragments.watermark.loadLabel": {
    "defaultMessage": "Charger le filigrane"
  },
  "admin.fragments.watermark.opacity": {
    "defaultMessage": "Opacité"
  },
  "admin.fragments.watermark.paddingX": {
    "defaultMessage": "Padding X"
  },
  "admin.fragments.watermark.paddingY": {
    "defaultMessage": "Padding Y"
  },
  "admin.fragments.watermark.positionBottom": {
    "defaultMessage": "Bas"
  },
  "admin.fragments.watermark.positionCenter": {
    "defaultMessage": "Centre"
  },
  "admin.fragments.watermark.positionLeft": {
    "defaultMessage": "Gauche"
  },
  "admin.fragments.watermark.positionRight": {
    "defaultMessage": "Droite"
  },
  "admin.fragments.watermark.positionTitle": {
    "defaultMessage": "Position"
  },
  "admin.fragments.watermark.positionTop": {
    "defaultMessage": "Haut"
  },
  "admin.fragments.watermark.positionX": {
    "defaultMessage": "Position X"
  },
  "admin.fragments.watermark.positionY": {
    "defaultMessage": "Position Y"
  },
  "admin.groups.addScreen.helpLinkText": {
    "defaultMessage": "Qu'est-ce qu'un groupe ?"
  },
  "admin.groups.alertsScreen.title": {
    "defaultMessage": "Alerts"
  },
  "admin.groups.deleteScreen.btn": {
    "defaultMessage": "Delete group"
  },
  "admin.groups.deleteScreen.prompt": {
    "defaultMessage": "Voulez-vous vraiment supprimer le groupe <b>{name}</b> ? {br} Cette action est irréversible."
  },
  "admin.groups.deleteScreen.title": {
    "defaultMessage": "Supprimer le groupe"
  },
  "admin.groups.editScreen.title": {
    "defaultMessage": "Edit group"
  },
  "admin.groups.filters.namePlaceholder": {
    "defaultMessage": "Rechercher par nom"
  },
  "admin.groups.form.name.label": {
    "defaultMessage": "Name"
  },
  "admin.groups.form.name.placeholder": {
    "defaultMessage": "For example \"Top Stations Users\""
  },
  "admin.groups.form.users.help": {
    "defaultMessage": "<b>NOTE:</b> users may belong to only one group. Selected users which are linked to other groups will be overridden."
  },
  "admin.groups.form.users.label": {
    "defaultMessage": "Assigned users"
  },
  "admin.groups.form.users.noMore": {
    "defaultMessage": "No more available users"
  },
  "admin.groups.help.assignGroup": {
    "defaultMessage": "En définissant le groupe d'un utilisateur, il aura accès à toutes les stations auxquelles le groupe a accès. Vous pouvez gérer les permissions de chaque groupe sous <strong>Administration {'>'} Station {'>'} Permissions des groupes</strong>."
  },
  "admin.groups.help.intro": {
    "defaultMessage": "Les <strong>groupes</strong> sont une méthode utile pour organiser les utilisateurs et contrôler l'accès et les permissions des stations de manière simple."
  },
  "admin.groups.help.oneGroup": {
    "defaultMessage": "Un utilisateur ne peut appartenir qu'à <strong>un</strong> groupe. Si vous devez donner un accès spécifique à un utilisateur au-delà de son groupe assigné, vous pouvez assigner une permission individuelle sous <strong>Administration {'>'} Station {'>'} Permissions utilisateurs</strong>."
  },
  "admin.groups.listScreen.links.createGroup": {
    "defaultMessage": "Créer un groupe"
  },
  "admin.groups.listScreen.noGroups": {
    "defaultMessage": "Aucun groupe trouvé"
  },
  "admin.groups.listScreen.title": {
    "defaultMessage": "Gérer les groupes"
  },
  "admin.groups.listScreen.usersCountHeader": {
    "defaultMessage": "# Utilisateurs"
  },
  "admin.groups.notifications.created": {
    "defaultMessage": "Groupe créé"
  },
  "admin.groups.notifications.deleted": {
    "defaultMessage": "Group deleted"
  },
  "admin.groups.notifications.updated": {
    "defaultMessage": "Groupe mis à jour"
  },
  "admin.groups.viewScreen.actionsPermissionsTab": {
    "defaultMessage": "Permisos de acciones"
  },
  "admin.groups.viewScreen.assignedUsers.body": {
    "defaultMessage": "Este grupo <b> {count, plural, =0 {no tiene} one {tiene #} other {tiene #} } </b> {count, plural, one {usuario asignado} other {usuarios asignados} }"
  },
  "admin.groups.viewScreen.assignedUsers.title": {
    "defaultMessage": "Utilisateurs assignés"
  },
  "admin.groups.viewScreen.basicInfoTab": {
    "defaultMessage": "Info"
  },
  "admin.groups.viewScreen.notDeletableHelp": {
    "defaultMessage": "This group can't be deleted because it contains assigned users"
  },
  "admin.groups.viewScreen.permissions.filterPlaceholder": {
    "defaultMessage": "Filter stations"
  },
  "admin.groups.viewScreen.permissions.noFilterMatch": {
    "defaultMessage": "No matching stations found"
  },
  "admin.groups.viewScreen.permissions.updateError": {
    "defaultMessage": "Could not update permission"
  },
  "admin.groups.viewScreen.stationsPermissionsTab": {
    "defaultMessage": "Permisos de estaciones"
  },
  "admin.integrations.accept": {
    "defaultMessage": "Accept"
  },
  "admin.integrations.cancel": {
    "defaultMessage": "Cancel"
  },
  "admin.integrations.warningTitle": {
    "defaultMessage": "Atention"
  },
  "admin.permissions.reset": {
    "defaultMessage": "Réinitialiser"
  },
  "admin.permissions.resetPermissions": {
    "defaultMessage": "Réinitialiser les permissions"
  },
  "admin.permissions.resetPermissionsPrompt": {
    "defaultMessage": "Êtes-vous sûr de vouloir réinitialiser toutes les permissions ? Cette action ne peut pas être annulée."
  },
  "admin.permissionsLabel": {
    "defaultMessage": "Admin"
  },
  "admin.socialExport.body": {
    "defaultMessage": "Configurer l'upload vers {platformName} pour les fragments"
  },
  "admin.socialExport.title": {
    "defaultMessage": "Intégration avec {name}"
  },
  "admin.stations.editScreen.title": {
    "defaultMessage": "Edit station"
  },
  "admin.stations.filters.namePlaceholder": {
    "defaultMessage": "Rechercher par nom"
  },
  "admin.stations.listScreen.title": {
    "defaultMessage": "Stations"
  },
  "admin.stations.viewScreen.basicInfo": {
    "defaultMessage": "Info"
  },
  "admin.stations.viewScreen.groups": {
    "defaultMessage": "Groupes"
  },
  "admin.stations.viewScreen.groupsFilter": {
    "defaultMessage": "Filter groups"
  },
  "admin.stations.viewScreen.groupsPermissions": {
    "defaultMessage": "Permissions des groupes"
  },
  "admin.stations.viewScreen.logo": {
    "defaultMessage": "Logo"
  },
  "admin.stations.viewScreen.noGroups": {
    "defaultMessage": "Aucun groupe trouvé"
  },
  "admin.stations.viewScreen.noGroupsFound": {
    "defaultMessage": "No matching groups found"
  },
  "admin.stations.viewScreen.noUsersFound": {
    "defaultMessage": "Aucun utilisateur trouvé"
  },
  "admin.stations.viewScreen.permissionInherited": {
    "defaultMessage": "Permission héritée du groupe {groupName}"
  },
  "admin.stations.viewScreen.permissionUpdateError": {
    "defaultMessage": "Could not update permission"
  },
  "admin.stations.viewScreen.userLinkText": {
    "defaultMessage": "View user info"
  },
  "admin.stations.viewScreen.usersFilter": {
    "defaultMessage": "Filter users"
  },
  "admin.stations.viewScreen.usersPermissions": {
    "defaultMessage": "Permissions des utilisateurs"
  },
  "admin.tagGroups.deleteGroupConfirm": {
    "defaultMessage": "Êtes-vous sûr de vouloir supprimer le groupe ?"
  },
  "admin.tagGroups.deleteGroupTitle": {
    "defaultMessage": "Supprimer le groupe"
  },
  "admin.tagGroups.newGroupName": {
    "defaultMessage": "Nouveau groupe"
  },
  "admin.sidebar.configuration": {
    "defaultMessage": "Features"
  },
  "admin.sidebar.groups": {
    "defaultMessage": "Groupes"
  },
  "admin.sidebar.integrations": {
    "defaultMessage": "Plateformes"
  },
  "admin.sidebar.stationGroups": {
    "defaultMessage": "Groupes de stations"
  },
  "admin.stationGroups.breadcrumb": {
    "defaultMessage": "Groupes de stations"
  },
  "admin.stationGroups.filters.namePlaceholder": {
    "defaultMessage": "Rechercher par nom"
  },
  "admin.stationGroups.listScreen.stationsCountHeader": {
    "defaultMessage": "# Stations"
  },
  "admin.stationGroups.listScreen.title": {
    "defaultMessage": "Groupes de stations"
  },
  "admin.stationGroups.viewScreen.accessType": {
    "defaultMessage": "Accès"
  },
  "admin.stationGroups.viewScreen.accessType.owned": {
    "defaultMessage": "Propre"
  },
  "admin.stationGroups.viewScreen.accessType.shared": {
    "defaultMessage": "Partagé"
  },
  "admin.stationGroups.viewScreen.noStations": {
    "defaultMessage": "Aucune station dans ce groupe"
  },
  "admin.stationGroups.viewScreen.slug": {
    "defaultMessage": "Slug"
  },
  "admin.stationGroups.viewScreen.stations": {
    "defaultMessage": "Stations"
  },
  "admin.sidebar.organization": {
    "defaultMessage": "Organisation"
  },
  "admin.title": {
    "defaultMessage": "Admin"
  },
  "admin.users.addScreen.title": {
    "defaultMessage": "Create user"
  },
  "admin.users.deleteScreen.prompt": {
    "defaultMessage": "Do you want to delete the user <b>{email}</b>? {br} This action can not be undone."
  },
  "admin.users.deleteScreen.title": {
    "defaultMessage": "Supprimer l'utilisateur"
  },
  "admin.users.editScreen.title": {
    "defaultMessage": "Edit user"
  },
  "admin.users.form.errors.errorUserExistsNotification": {
    "defaultMessage": "User already exists"
  },
  "admin.users.form.group.label": {
    "defaultMessage": "Group"
  },
  "admin.users.form.group.noGroup": {
    "defaultMessage": "No group"
  },
  "admin.users.form.name.label": {
    "defaultMessage": "Name"
  },
  "admin.users.filters.emailPlaceholder": {
    "defaultMessage": "Rechercher par e-mail"
  },
  "admin.users.filters.namePlaceholder": {
    "defaultMessage": "Rechercher par nom"
  },
  "admin.users.form.surname.label": {
    "defaultMessage": "Surname"
  },
  "admin.users.lastLogin": {
    "defaultMessage": "Dernière connexion"
  },
  "admin.users.listScreen.links.createUser": {
    "defaultMessage": "Créer un utilisateur"
  },
  "admin.users.listScreen.title": {
    "defaultMessage": "Gérer les utilisateurs"
  },
  "admin.users.loginMethod.label": {
    "defaultMessage": "Méthode de connexion"
  },
  "admin.users.loginMethod.SOCIAL_LOGIN.description": {
    "defaultMessage": "L'utilisateur utilisera son compte email existant sur Google pour se connecter."
  },
  "admin.users.loginMethod.SOCIAL_LOGIN.label": {
    "defaultMessage": "Connexion avec Google"
  },
  "admin.users.loginMethod.USERNAME_PASSWORD.description": {
    "defaultMessage": "L'utilisateur recevra un email avec les instructions pour configurer son compte"
  },
  "admin.users.loginMethod.USERNAME_PASSWORD.label": {
    "defaultMessage": "Nom d'utilisateur et mot de passe"
  },
  "admin.users.name": {
    "defaultMessage": "Nom"
  },
  "admin.users.notifications.created": {
    "defaultMessage": "User created"
  },
  "admin.users.notifications.deleted": {
    "defaultMessage": "User deleted"
  },
  "admin.users.notifications.updated": {
    "defaultMessage": "User updated"
  },
  "admin.users.role": {
    "defaultMessage": "Rôle"
  },
  "admin.users.roles.label": {
    "defaultMessage": "User role"
  },
  "admin.users.roles.values.CLIENT_ADMIN.description": {
    "defaultMessage": "Utilisateur administrateur du client"
  },
  "admin.users.roles.values.CLIENT_ADMIN.label": {
    "defaultMessage": "Administrateur"
  },
  "admin.users.roles.values.CLIENT_USER.description": {
    "defaultMessage": "Utilisateur standard du client"
  },
  "admin.users.roles.values.CLIENT_USER.label": {
    "defaultMessage": "Basique"
  },
  "admin.users.roles.values.SUPERADMIN.description": {
    "defaultMessage": "Administrateur du système"
  },
  "admin.users.roles.values.SUPERADMIN.label": {
    "defaultMessage": "Super administrateur"
  },
  "admin.users.title": {
    "defaultMessage": "Utilisateurs"
  },
  "admin.users.viewScreen.actionsPermissionsTab": {
    "defaultMessage": "Permisos de acciones"
  },
  "admin.users.viewScreen.assignedGroup.noGroup": {
    "defaultMessage": "- Aucun groupe -"
  },
  "admin.users.viewScreen.assignedGroup.title": {
    "defaultMessage": "Groupe assigné"
  },
  "admin.users.viewScreen.basicInfoTab": {
    "defaultMessage": "Info"
  },
  "admin.users.viewScreen.fullName": {
    "defaultMessage": "Nom complet"
  },
  "admin.users.viewScreen.permissions.clientAdminAllStationsAccess": {
    "defaultMessage": "Les utilisateurs administrateurs ont accès à toutes les stations par défaut."
  },
  "admin.users.viewScreen.permissions.filterPlaceholder": {
    "defaultMessage": "Filter stations"
  },
  "admin.users.viewScreen.permissions.noFilterMatch": {
    "defaultMessage": "No matching stations found"
  },
  "admin.users.viewScreen.permissions.updateError": {
    "defaultMessage": "Could not update permission"
  },
  "admin.users.viewScreen.stationsPermissionsTab": {
    "defaultMessage": "Stations permissions"
  },
  "admin.users.viewScreen.userRole": {
    "defaultMessage": "Rôle utilisateur"
  },
  "admin.videoAnalysis.adOverlays.ignoredEntities": {
    "defaultMessage": "Entités ignorées"
  },
  "admin.videoAnalysis.adOverlays.notEnabledForStation": {
    "defaultMessage": "Ad Overlays non activé pour cette station"
  },
  "admin.videoAnalysis.adOverlays.numericAllowlist": {
    "defaultMessage": "Liste numérique autorisée"
  },
  "admin.videoAnalysis.adOverlays.title": {
    "defaultMessage": "Ad Overlays"
  },
  "admin.videoAnalysis.settingsUpdated": {
    "defaultMessage": "Paramètres mis à jour"
  },
  "assets.fileUploaded": {
    "defaultMessage": "Fichier téléchargé"
  },
  "assets.upload.error": {
    "defaultMessage": "Une erreur s'est produite lors du téléchargement du fichier, veuillez réessayer"
  },
  "assets.upload.errorFileSizeExceeded": {
    "defaultMessage": "Les fichiers ne doivent pas dépasser {maxSizeMb} Mo"
  },
  "assets.upload.label": {
    "defaultMessage": "Télécharger la ressource"
  },
  "assets.upload.maxSize": {
    "defaultMessage": "Max. {max}Mo."
  },
  "assets.viewFile": {
    "defaultMessage": "Voir le fichier"
  },
  "audit.adaptiveRun.noActions": {
    "defaultMessage": "Aucune action"
  },
  "audit.adoverlayScreen.brand": {
    "defaultMessage": "Brand"
  },
  "audit.adoverlayScreen.duration": {
    "defaultMessage": "Duration"
  },
  "audit.adoverlayScreen.image": {
    "defaultMessage": "Image"
  },
  "audit.adoverlayScreen.loading": {
    "defaultMessage": "Chargement des ad overlays"
  },
  "audit.adoverlayScreen.noResults": {
    "defaultMessage": "Aucun ad overlay trouvé"
  },
  "audit.aod.actions.acceptRun": {
    "defaultMessage": "Accepter"
  },
  "audit.aod.actions.acceptRun.description": {
    "defaultMessage": "Accepter le résultat du rapport et réexécuter pour qu'il soit exporté"
  },
  "audit.aod.actions.acceptRun.reason": {
    "defaultMessage": "Raison (optionnel)"
  },
  "audit.aod.actions.acceptRun.reason.placeholder": {
    "defaultMessage": "Entrez une raison optionnelle pour accepter cette exécution"
  },
  "audit.aod.actions.downloadExport": {
    "defaultMessage": "Télécharger export"
  },
  "audit.aod.actions.goToReport": {
    "defaultMessage": "Aller au rapport"
  },
  "audit.aod.actions.orderReprocess": {
    "defaultMessage": "Retraiter la commande {orderId}"
  },
  "audit.aod.actions.orderReprocess.completed": {
    "defaultMessage": "Commande {orderId} retraitée"
  },
  "audit.aod.actions.orderReprocess.completed.multiple": {
    "defaultMessage": "Commandes retraitées : {currentOrders}"
  },
  "audit.aod.actions.orderReprocess.confirm.button": {
    "defaultMessage": "Confirmer"
  },
  "audit.aod.actions.orderReprocess.confirm.message": {
    "defaultMessage": "Êtes-vous sûr de vouloir démarrer le retraitement de la commande {orderId}?"
  },
  "audit.aod.actions.orderReprocess.confirm.message.withKey": {
    "defaultMessage": "Êtes-vous sûr de vouloir démarrer le retraitement de la commande {orderId}? (key: {key})"
  },
  "audit.aod.actions.orderReprocess.confirm.title": {
    "defaultMessage": "Confirmer le retraitement"
  },
  "audit.aod.actions.orderReprocess.multiple": {
    "defaultMessage": "Retraiter {count} commandes"
  },
  "audit.aod.actions.orderReprocess.processing": {
    "defaultMessage": "Retraitement de la commande {orderId}"
  },
  "audit.aod.actions.orderReprocess.processing.multiple": {
    "defaultMessage": "Retraitement des commandes {currentOrders}"
  },
  "audit.aod.actions.orderReprocess.reprocessedOn": {
    "defaultMessage": "Retraité le {date}"
  },
  "audit.aod.actions.orderReprocess.reprocessedOn.withKey": {
    "defaultMessage": "Retraité le {date} (key: {key})"
  },
  "audit.aod.actions.refreshRun": {
    "defaultMessage": "Actualiser"
  },
  "audit.aod.actions.refreshRun.description": {
    "defaultMessage": "Réexécuter avec les résultats existants sans modifier les conditions d'export"
  },
  "audit.aod.actions.refreshRun.description.missingMaterials": {
    "defaultMessage": "Après avoir chargé les matériaux manquants, actualisez l'exécution pour réévaluer le rapport."
  },
  "audit.aod.actions.restartRun": {
    "defaultMessage": "Redémarrer l'exécution"
  },
  "audit.aod.actions.restartRun.message": {
    "defaultMessage": "Êtes-vous sûr de vouloir redémarrer cette exécution ? Cette action supprimera son rapport et remettra le traitement en file d'attente."
  },
  "audit.aod.actions.restartRun.title": {
    "defaultMessage": "Redémarrer l'exécution"
  },
  "audit.aod.actions.triggerReprocess": {
    "defaultMessage": "Retraiter"
  },
  "audit.aod.actions.triggerReprocess.completed": {
    "defaultMessage": "Retraitement terminé"
  },
  "audit.aod.actions.triggerReprocess.description": {
    "defaultMessage": "Démarrer le retraitement de la commande puis réexécuter"
  },
  "audit.aod.actions.triggerReprocess.error": {
    "defaultMessage": "Impossible de démarrer le retraitement"
  },
  "audit.aod.actions.triggerReprocess.error.missingMaterials": {
    "defaultMessage": "Retraitement impossible : matériaux manquants. Chargez les audios et actualisez l'exécution."
  },
  "audit.aod.actions.triggerReprocess.failed.message": {
    "defaultMessage": "Une erreur s'est produite lors du retraitement"
  },
  "audit.aod.actions.triggerReprocess.failed.missingSegments": {
    "defaultMessage": "Segments manquants"
  },
  "audit.aod.actions.triggerReprocess.failed.missingSpotMedia": {
    "defaultMessage": "Média spot manquant"
  },
  "audit.aod.actions.triggerReprocess.failed.title": {
    "defaultMessage": "Erreur lors du dernier retraitement"
  },
  "audit.aod.actions.triggerReprocess.missingMaterials.description": {
    "defaultMessage": "Les schedules sans match n'ont pas de médias spot liés. Chargez les matériaux et actualisez l'exécution ; le retraitement OLAF ne peut pas aider sans audio."
  },
  "audit.aod.actions.triggerReprocess.missingMaterials.title": {
    "defaultMessage": "Retraitement indisponible"
  },
  "audit.aod.actions.triggerReprocess.startedAt": {
    "defaultMessage": "Démarré le"
  },
  "audit.aod.actions.triggerReprocess.waiting": {
    "defaultMessage": "Le retraitement est en attente de démarrage"
  },
  "audit.aod.actions.viewResults": {
    "defaultMessage": "Voir les résultats"
  },
  "audit.aod.exportConditions.description": {
    "defaultMessage": "Description"
  },
  "audit.aod.exportConditions.description.placeholder": {
    "defaultMessage": "Description optionnelle de cette exécution manuelle"
  },
  "audit.aod.exportConditions.enableEfficiency": {
    "defaultMessage": "Vérifier l'efficacité minimale"
  },
  "audit.aod.exportConditions.minEfficiency": {
    "defaultMessage": "Efficacité minimale"
  },
  "audit.aod.exportConditions.minEfficiency.help": {
    "defaultMessage": "Efficacité minimale (0 à 100 %)"
  },
  "audit.aod.exportConditions.minEfficiency.placeholder": {
    "defaultMessage": "0 - 100"
  },
  "audit.aod.gip.atLeastOneAdvertiser": {
    "defaultMessage": "Au moins un annonceur doit être sélectionné"
  },
  "audit.aod.gip.export.packageStorageStrategy.PER_RULE": {
    "defaultMessage": "Par règle"
  },
  "audit.aod.gip.export.packageStorageStrategy.PER_RUN": {
    "defaultMessage": "Par exécution"
  },
  "audit.aod.gip.export.packageStorageStrategyLabel": {
    "defaultMessage": "Stockage du paquet"
  },
  "audit.aod.gip.order": {
    "defaultMessage": "Commande"
  },
  "audit.aod.review.evidenceExportTitle": {
    "defaultMessage": "Export des preuves"
  },
  "audit.aod.review.exportConditionsTitle": {
    "defaultMessage": "Conditions d'export"
  },
  "audit.aod.review.reportConfigTitle": {
    "defaultMessage": "Configuration du rapport"
  },
  "audit.aod.rules.active": {
    "defaultMessage": "Actif"
  },
  "audit.aod.rules.add": {
    "defaultMessage": "Créer une règle"
  },
  "audit.aod.rules.add.reportType": {
    "defaultMessage": "Type de rapport"
  },
  "audit.aod.rules.addScreen.title": {
    "defaultMessage": "Créer une règle AOD"
  },
  "audit.aod.rules.createdAt": {
    "defaultMessage": "Créée"
  },
  "audit.aod.rules.createdBy": {
    "defaultMessage": "par"
  },
  "audit.aod.rules.delete.message": {
    "defaultMessage": "Êtes-vous sûr de vouloir supprimer la règle « {name} » ? Cette action est irréversible."
  },
  "audit.aod.rules.delete.title": {
    "defaultMessage": "Supprimer la règle AOD"
  },
  "audit.aod.rules.edit.updateBtn": {
    "defaultMessage": "Mettre à jour la règle"
  },
  "audit.aod.rules.editScreen.title": {
    "defaultMessage": "Modifier la règle AOD"
  },
  "audit.aod.rules.field.active": {
    "defaultMessage": "Estado"
  },
  "audit.aod.rules.field.createdAt": {
    "defaultMessage": "Créée"
  },
  "audit.aod.rules.field.name": {
    "defaultMessage": "Nom"
  },
  "audit.aod.rules.field.reportType": {
    "defaultMessage": "Tipo de reporte"
  },
  "audit.aod.rules.field.trigger": {
    "defaultMessage": "Trigger"
  },
  "audit.aod.rules.managers": {
    "defaultMessage": "Responsables"
  },
  "audit.aod.rules.managers.help": {
    "defaultMessage": "Sélectionnez les utilisateurs qui seront responsables de cette règle"
  },
  "audit.aod.rules.managers.placeholder": {
    "defaultMessage": "Sélectionner des utilisateurs"
  },
  "audit.aod.rules.manualRun.exportConditions": {
    "defaultMessage": "Conditions d'export"
  },
  "audit.aod.rules.manualRun.exportConditionsDescription": {
    "defaultMessage": "Modifiez les conditions d'export pour cette exécution manuelle. Les changements ne s'appliqueront qu'à cette exécution."
  },
  "audit.aod.rules.manualRun.notifications.error": {
    "defaultMessage": "Erreur lors du démarrage de l'exécution manuelle"
  },
  "audit.aod.rules.manualRun.notifications.triggered": {
    "defaultMessage": "Exécution manuelle démarrée"
  },
  "audit.aod.rules.manualRun.submit": {
    "defaultMessage": "Démarrer l'exécution manuelle"
  },
  "audit.aod.rules.manualRunScreen.title": {
    "defaultMessage": "Exécuter la règle AOD manuellement"
  },
  "audit.aod.rules.name": {
    "defaultMessage": "Nom"
  },
  "audit.aod.rules.name.placeholder": {
    "defaultMessage": "Entrez le nom de la règle"
  },
  "audit.aod.rules.notificationPolicy.ALWAYS": {
    "defaultMessage": "Toujours (fin de semaine et fin de commande)"
  },
  "audit.aod.rules.notificationPolicy.label": {
    "defaultMessage": "Politique de notification"
  },
  "audit.aod.rules.notificationPolicy.NONE": {
    "defaultMessage": "Aucune notification"
  },
  "audit.aod.rules.notificationPolicy.ORDER_END_ONLY": {
    "defaultMessage": "Fin de commande uniquement"
  },
  "audit.aod.rules.notifications.created": {
    "defaultMessage": "Règle AOD créée"
  },
  "audit.aod.rules.notifications.createError": {
    "defaultMessage": "Erreur lors de la création de la règle AOD."
  },
  "audit.aod.rules.notifications.deleted": {
    "defaultMessage": "Règle AOD supprimée"
  },
  "audit.aod.rules.notifications.deleteError": {
    "defaultMessage": "Erreur lors de la suppression de la règle AOD"
  },
  "audit.aod.rules.notifications.updated": {
    "defaultMessage": "Règle AOD mise à jour"
  },
  "audit.aod.rules.notifications.updateError": {
    "defaultMessage": "Erreur lors de la mise à jour de la règle AOD"
  },
  "audit.aod.rules.reportType": {
    "defaultMessage": "Type de rapport"
  },
  "audit.aod.rules.review.basicInfo": {
    "defaultMessage": "Informations de base"
  },
  "audit.aod.rules.review.createBtn": {
    "defaultMessage": "Créer la règle"
  },
  "audit.aod.rules.rule": {
    "defaultMessage": "Règle"
  },
  "audit.aod.rules.title": {
    "defaultMessage": "Règles"
  },
  "audit.aod.rules.trigger": {
    "defaultMessage": "Déclencheur"
  },
  "audit.aod.rules.trigger.EOW": {
    "defaultMessage": "Clôture hebdomadaire"
  },
  "audit.aod.rules.trigger.EOW_AND_ORDER_END": {
    "defaultMessage": "Clôture hebdomadaire + fin de commande"
  },
  "audit.aod.rules.trigger.EOW_AND_ORDER_END_SHORT": {
    "defaultMessage": "Clôture + fin"
  },
  "audit.aod.rules.trigger.MANUAL": {
    "defaultMessage": "Manuel"
  },
  "audit.aod.rules.trigger.ORDER_END": {
    "defaultMessage": "Fin de commande"
  },
  "audit.aod.rules.view.runs.navigation.activeAndPast": {
    "defaultMessage": "Exécutions actives/passées"
  },
  "audit.aod.rules.view.runs.navigation.future": {
    "defaultMessage": "Ejecuciones Programadas"
  },
  "audit.aod.rules.view.runs.noFutureRuns": {
    "defaultMessage": "Aucune exécution programmée pour cette règle."
  },
  "audit.aod.rules.view.runs.triggerManual": {
    "defaultMessage": "Exécuter manuellement"
  },
  "audit.aod.rules.view.tabs.exportConditions": {
    "defaultMessage": "Conditions d'export"
  },
  "audit.aod.rules.view.tabs.exportOptions": {
    "defaultMessage": "Opciones de Export"
  },
  "audit.aod.rules.view.tabs.info": {
    "defaultMessage": "Informations"
  },
  "audit.aod.rules.view.tabs.reportConfig": {
    "defaultMessage": "Configuration du rapport"
  },
  "audit.aod.rules.view.tabs.runs": {
    "defaultMessage": "Exécutions"
  },
  "audit.aod.rules.wizard.basicInfo": {
    "defaultMessage": "Informations de base"
  },
  "audit.aod.rules.wizard.exportConditions": {
    "defaultMessage": "Conditions d'export"
  },
  "audit.aod.rules.wizard.exportOptions": {
    "defaultMessage": "Export des preuves"
  },
  "audit.aod.rules.wizard.reportConfig": {
    "defaultMessage": "Configuration du rapport"
  },
  "audit.aod.rules.wizard.review": {
    "defaultMessage": "Révision"
  },
  "audit.aod.runs.actions.triggerRunCopy": {
    "defaultMessage": "Exécuter la copie maintenant"
  },
  "audit.aod.runs.actions.triggerRunCopySuccess": {
    "defaultMessage": "Exécution démarrée"
  },
  "audit.aod.runs.actions.viewRule": {
    "defaultMessage": "Aller à la règle"
  },
  "audit.aod.runs.completionReason.LOW_EFFICIENCY": {
    "defaultMessage": "Faible efficacité"
  },
  "audit.aod.runs.completionReason.MISSING_MATERIALS": {
    "defaultMessage": "Matériaux manquants"
  },
  "audit.aod.runs.datetime": {
    "defaultMessage": "Exécutée"
  },
  "audit.aod.runs.field.actions": {
    "defaultMessage": "Actions"
  },
  "audit.aod.runs.field.completionComment": {
    "defaultMessage": "Commentaire"
  },
  "audit.aod.runs.field.completionReason": {
    "defaultMessage": "Motif"
  },
  "audit.aod.runs.field.deficiencyNotificationsSent": {
    "defaultMessage": "Notifications de déficience envoyées"
  },
  "audit.aod.runs.field.deficiencyNotificationsUsers": {
    "defaultMessage": "Utilisateurs notifiés"
  },
  "audit.aod.runs.field.description": {
    "defaultMessage": "Description"
  },
  "audit.aod.runs.field.efficiency": {
    "defaultMessage": "Efficacité"
  },
  "audit.aod.runs.field.interval": {
    "defaultMessage": "Intervalle"
  },
  "audit.aod.runs.field.minEfficiency": {
    "defaultMessage": "Efficacité minimale requise"
  },
  "audit.aod.runs.field.order": {
    "defaultMessage": "Commande"
  },
  "audit.aod.runs.field.ruleName": {
    "defaultMessage": "Règle"
  },
  "audit.aod.runs.field.runAt": {
    "defaultMessage": "Ejecutada en"
  },
  "audit.aod.runs.field.status": {
    "defaultMessage": "État"
  },
  "audit.aod.runs.field.type": {
    "defaultMessage": "Type"
  },
  "audit.aod.runs.interval": {
    "defaultMessage": "Intervalle"
  },
  "audit.aod.runs.name": {
    "defaultMessage": "Nom"
  },
  "audit.aod.runs.order": {
    "defaultMessage": "Commande"
  },
  "audit.aod.runs.reportType": {
    "defaultMessage": "Type de rapport"
  },
  "audit.aod.runs.rule": {
    "defaultMessage": "Règle"
  },
  "audit.aod.runs.ruleName": {
    "defaultMessage": "Règle"
  },
  "audit.aod.runs.scheduledAt": {
    "defaultMessage": "Programmée"
  },
  "audit.aod.runs.status": {
    "defaultMessage": "État"
  },
  "audit.aod.runs.status.completed_with_export": {
    "defaultMessage": "Exécutée avec export"
  },
  "audit.aod.runs.status.completed_without_export": {
    "defaultMessage": "Exécutée sans export"
  },
  "audit.aod.runs.status.failed": {
    "defaultMessage": "Échec"
  },
  "audit.aod.runs.status.in_progress": {
    "defaultMessage": "En cours"
  },
  "audit.aod.runs.status.pending": {
    "defaultMessage": "En attente"
  },
  "audit.aod.runs.status.waiting_for_reprocess": {
    "defaultMessage": "En attente de retraitement"
  },
  "audit.aod.runs.title": {
    "defaultMessage": "Exécutions"
  },
  "audit.aod.runs.type": {
    "defaultMessage": "Déclencheur"
  },
  "audit.aod.runs.userAccepted.intro": {
    "defaultMessage": "Exécution acceptée manuellement par l'utilisateur"
  },
  "audit.aod.runs.userAccepted.reason": {
    "defaultMessage": "Raison :"
  },
  "audit.aod.runs.userReprocess.intro": {
    "defaultMessage": "Retraitement manuel demandé par l'utilisateur"
  },
  "audit.aod.runs.userReprocess.onDate": {
    "defaultMessage": "le"
  },
  "audit.aod.runs.userReprocess.unknownUser": {
    "defaultMessage": "utilisateur inconnu"
  },
  "audit.aod.tabs.rules": {
    "defaultMessage": "Règles"
  },
  "audit.aod.tabs.runsPast": {
    "defaultMessage": "Exécutions passées"
  },
  "audit.aod.tabs.runsScheduled": {
    "defaultMessage": "Exécutions programmées"
  },
  "audit.aod.titleLong": {
    "defaultMessage": "Automatic Order Delivery"
  },
  "audit.audiosScreen.customData.name": {
    "defaultMessage": "Nom"
  },
  "audit.audiosScreen.customData.value": {
    "defaultMessage": "Valeur"
  },
  "audit.audiosScreen.customDataTitle": {
    "defaultMessage": "Données personnalisées de {customId}"
  },
  "audit.audiosScreen.group": {
    "defaultMessage": "Groupe"
  },
  "audit.audiosScreen.mediaTitle": {
    "defaultMessage": "Media"
  },
  "audit.audiosScreen.props.audioId": {
    "defaultMessage": "Audio ID"
  },
  "audit.audiosScreen.props.date": {
    "defaultMessage": "Uploaded at"
  },
  "audit.audiosScreen.props.duration": {
    "defaultMessage": "Duration"
  },
  "audit.audiosScreen.props.filename": {
    "defaultMessage": "Filename"
  },
  "audit.audiosScreen.showCustomData": {
    "defaultMessage": "Afficher les données personnalisées"
  },
  "audit.audiosScreen.showTranscription": {
    "defaultMessage": "Afficher la transcription"
  },
  "audit.audiosScreen.tabTitle": {
    "defaultMessage": "Media"
  },
  "audit.audiosScreen.title": {
    "defaultMessage": "Uploaded audios"
  },
  "audit.audiosScreen.transcriptionTitle": {
    "defaultMessage": "Transcription de {customId}"
  },
  "audit.auditConfig.materials": {
    "defaultMessage": "Matériaux"
  },
  "audit.bcr.label": {
    "defaultMessage": "BCR"
  },
  "audit.bcr.verifiedWithBcr": {
    "defaultMessage": "Vérifié avec BCR"
  },
  "audit.bcrMatchesReport.emptyState.help": {
    "defaultMessage": "Compare les logs BCR importés avec les matches du système pour le jour sélectionné. Permet de vérifier quelles diffusions du log externe ont été confirmées et lesquelles ne l'ont pas été."
  },
  "audit.branding.headerBackgroundColor": {
    "defaultMessage": "Couleur de fond de l'en-tête"
  },
  "audit.broadcastEvidence.downloadPackage": {
    "defaultMessage": "Télécharger la preuve (ZIP)"
  },
  "audit.broadcastEvidence.downloadPending": {
    "defaultMessage": "Package de preuve non disponible"
  },
  "audit.broadcastEvidence.evidenceTitle": {
    "defaultMessage": "Preuves"
  },
  "audit.broadcastEvidence.jobStatus": {
    "defaultMessage": "État"
  },
  "audit.broadcastEvidence.localDate": {
    "defaultMessage": "Date"
  },
  "audit.broadcastEvidence.orderId": {
    "defaultMessage": "Commande"
  },
  "audit.broadcastEvidence.packageTitle": {
    "defaultMessage": "Export de preuve"
  },
  "audit.broadcastEvidence.scheduledMaterial": {
    "defaultMessage": "Matériel programmé"
  },
  "audit.broadcastEvidence.station": {
    "defaultMessage": "Station"
  },
  "audit.broadcastEvidence.summary.alternativeConfirmed": {
    "defaultMessage": "Confirmés"
  },
  "audit.broadcastEvidence.summary.olafMatched": {
    "defaultMessage": "OLAF"
  },
  "audit.broadcastEvidence.summary.outsideTolerance": {
    "defaultMessage": "Hors tolérance"
  },
  "audit.broadcastEvidence.summary.scheduled": {
    "defaultMessage": "Programmés"
  },
  "audit.broadcastEvidence.summary.withinTolerance": {
    "defaultMessage": "Dans la tolérance"
  },
  "audit.broadcastEvidence.table.broadcastDatetime": {
    "defaultMessage": "Diffusion"
  },
  "audit.broadcastEvidence.table.broadcastMaterialId": {
    "defaultMessage": "Matériel diffusé"
  },
  "audit.broadcastEvidence.table.methods": {
    "defaultMessage": "Méthodes"
  },
  "audit.broadcastEvidence.table.observation": {
    "defaultMessage": "Observation"
  },
  "audit.broadcastEvidence.table.scheduledMaterialId": {
    "defaultMessage": "Matériel programmé"
  },
  "audit.broadcastEvidence.table.status": {
    "defaultMessage": "État"
  },
  "audit.broadcastEvidence.table.withinTolerance": {
    "defaultMessage": "Tolérance"
  },
  "audit.broadcastEvidence.withinTolerance.no": {
    "defaultMessage": "Non"
  },
  "audit.broadcastEvidence.withinTolerance.yes": {
    "defaultMessage": "Oui"
  },
  "audit.column.moveToEnd": {
    "defaultMessage": "Déplacer à la fin"
  },
  "audit.column.moveToStart": {
    "defaultMessage": "Déplacer au début"
  },
  "audit.configScreen.excludedCustomIds.hint": {
    "defaultMessage": "Liste d'IDs personnalisés séparés par des virgules à exclure des rapports d'audit"
  },
  "audit.configScreen.excludedCustomIds.label": {
    "defaultMessage": "Exclure les IDs personnalisés"
  },
  "audit.configScreen.successMessage": {
    "defaultMessage": "Configuration d'audit mise à jour"
  },
  "audit.configScreen.title": {
    "defaultMessage": "Configuration d'audit"
  },
  "audit.confirmedBySchedule.filterByOrder": {
    "defaultMessage": "Voir les schedules de l'ordre {order}"
  },
  "audit.confirmedBySchedule.scheduleDatetime": {
    "defaultMessage": "Planning"
  },
  "audit.consecutiveSchedules.datetimeNext": {
    "defaultMessage": "Prochaine date/heure"
  },
  "audit.consecutiveSchedules.title": {
    "defaultMessage": "Schedules consécutifs"
  },
  "audit.controls.markers": {
    "defaultMessage": "Annotations"
  },
  "audit.diarization.processing": {
    "defaultMessage": "Traitement de la transcription"
  },
  "audit.equalMd5Report.customIds": {
    "defaultMessage": "IDs personnalisés"
  },
  "audit.equalMd5Report.emptyState.help": {
    "defaultMessage": "Liste les fichiers média qui partagent le même hash MD5 (c'est-à-dire le même contenu de fichier) mais sont enregistrés sous des IDs de matériel différents. Utile pour détecter et nettoyer les médias en double."
  },
  "audit.equalMd5Report.md5": {
    "defaultMessage": "MD5"
  },
  "audit.filesUpload.audioIdLabel": {
    "defaultMessage": "ID audio :"
  },
  "audit.filesUpload.entriesFoundToLoad": {
    "defaultMessage": "{n} entrées {type} à charger. Confirmez le chargement ou annulez pour revenir."
  },
  "audit.filesUpload.fileLabel": {
    "defaultMessage": "Fichier :"
  },
  "audit.filesUpload.filesLabel": {
    "defaultMessage": "Fichiers :"
  },
  "audit.filesUpload.links.adAudios": {
    "defaultMessage": "Médias Spot"
  },
  "audit.filesUpload.links.adSchedulesAsc": {
    "defaultMessage": "Grilles Spot (ASC)"
  },
  "audit.filesUpload.links.adSchedulesPlk": {
    "defaultMessage": "Grilles Spot (PLK)"
  },
  "audit.filesUpload.links.avgUpload": {
    "defaultMessage": "Téléverser AVG"
  },
  "audit.filesUpload.links.bcrUpload": {
    "defaultMessage": "Téléverser BCR"
  },
  "audit.filesUpload.links.liveMentionSchedulesCsv": {
    "defaultMessage": "Grilles de mentions (CSV)"
  },
  "audit.filesUpload.links.ltxUpload": {
    "defaultMessage": "Téléverser LTX"
  },
  "audit.filesUpload.materialId": {
    "defaultMessage": "ID matériel"
  },
  "audit.filesUpload.selectFileLabel": {
    "defaultMessage": "Sélectionner fichier(s) .{type}"
  },
  "audit.filesUpload.selectFileType": {
    "defaultMessage": "Sélectionnez un type de fichier dans le menu latéral"
  },
  "audit.filesUpload.uploadError": {
    "defaultMessage": "Ocurrió un error al subir el archivo:"
  },
  "audit.filesUpload.uploadFile": {
    "defaultMessage": "Confirmer le chargement"
  },
  "audit.filesUpload.uploadFiles": {
    "defaultMessage": "Confirmer le chargement"
  },
  "audit.filesUpload.uploading": {
    "defaultMessage": "Téléchargement en cours..."
  },
  "audit.filesUpload.uploadSuccess": {
    "defaultMessage": "Fichier téléchargé avec succès"
  },
  "audit.filesUpload.uploadSuccessMultiple": {
    "defaultMessage": "Fichiers téléchargés avec succès"
  },
  "audit.filesUpload.validateError": {
    "defaultMessage": "Une erreur s'est produite lors de la validation du fichier :"
  },
  "audit.gip.exportConditions.enableEfficiency": {
    "defaultMessage": "Vérifier l'efficacité minimale"
  },
  "audit.gip.exportConditions.minEfficiency": {
    "defaultMessage": "Efficacité minimale"
  },
  "audit.gip.report.efficiency": {
    "defaultMessage": "Efficacité"
  },
  "audit.gip.report.efficiencyHelp": {
    "defaultMessage": "Pourcentage de plannings traités qui ont une correspondance confirmée."
  },
  "audit.gip.report.missingMaterials": {
    "defaultMessage": "Médias manquants"
  },
  "audit.gip.report.missingMaterialsHelp": {
    "defaultMessage": "Nombre de médias référencés par des plannings qui ne sont pas encore chargés."
  },
  "audit.gip.report.results": {
    "defaultMessage": "Résultats"
  },
  "audit.gip.report.scheduleProgress": {
    "defaultMessage": "Progression des plannings"
  },
  "audit.gip.report.scheduleProgressHelp": {
    "defaultMessage": "Pourcentage de plannings déjà traités sur le total. Les plannings en attente et futurs ne sont pas encore comptés comme traités."
  },
  "audit.gip.report.summary": {
    "defaultMessage": "Résumé"
  },
  "audit.gip.report.totalSchedules": {
    "defaultMessage": "Total des plannings"
  },
  "audit.gip.report.withMatch": {
    "defaultMessage": "Avec correspondance"
  },
  "audit.gip.report.withoutMatch": {
    "defaultMessage": "Sans correspondance"
  },
  "audit.gipReport.columnMaterial": {
    "defaultMessage": "Matériel"
  },
  "audit.gipReport.columnStation": {
    "defaultMessage": "Station"
  },
  "audit.gipReport.configTitle": {
    "defaultMessage": "Configuration du rapport"
  },
  "audit.gipReport.createModal.createdNotification": {
    "defaultMessage": "Rapport créé avec succès"
  },
  "audit.gipReport.createModal.createdNotificationLink": {
    "defaultMessage": "Voir le rapport"
  },
  "audit.gipReport.createModal.nameLabel": {
    "defaultMessage": "Nom du rapport"
  },
  "audit.gipReport.createModal.namePlaceholder": {
    "defaultMessage": "Entrez le nom du rapport"
  },
  "audit.gipReport.createModal.title": {
    "defaultMessage": "Créer un rapport"
  },
  "audit.gipReport.error.dateRangeExceeded": {
    "defaultMessage": "La plage de dates ne peut pas dépasser {maxDays} jours."
  },
  "audit.gipReport.error.fromMustBeBeforeTo": {
    "defaultMessage": "La date de début doit être antérieure à la date de fin."
  },
  "audit.gipReport.excludedMatchesCount": {
    "defaultMessage": "{count, plural, one {match exclu} other {matches exclus}}"
  },
  "audit.gipReport.excludedMatchesLabel": {
    "defaultMessage": "Matches exclus de l'export"
  },
  "audit.gipReport.export.advancedLink": {
    "defaultMessage": "Avancé"
  },
  "audit.gipReport.export.audioMatchIncludeAfterLabel": {
    "defaultMessage": "Secondes à inclure après le match"
  },
  "audit.gipReport.export.audioMatchIncludeBeforeLabel": {
    "defaultMessage": "Secondes à inclure avant le match"
  },
  "audit.gipReport.export.audioMatchIncludeHelper": {
    "defaultMessage": "Entre 0 et 300 secondes"
  },
  "audit.gipReport.export.customTextInPath": {
    "defaultMessage": "Texte personnalisé dans le chemin"
  },
  "audit.gipReport.export.definition": {
    "defaultMessage": "Modèle"
  },
  "audit.gipReport.export.excludeVersion": {
    "defaultMessage": "Exclure la version"
  },
  "audit.gipReport.export.filesConfig": {
    "defaultMessage": "Configuration des fichiers"
  },
  "audit.gipReport.export.noTemplatesAvailable": {
    "defaultMessage": "Aucun modèle disponible"
  },
  "audit.gipReport.export.pathFormat": {
    "defaultMessage": "Format du chemin"
  },
  "audit.gipReport.export.publicLink": {
    "defaultMessage": "Lien public"
  },
  "audit.gipReport.export.retryBtn": {
    "defaultMessage": "Exporter à nouveau"
  },
  "audit.gipReport.export.startBtn": {
    "defaultMessage": "Démarrer l'export"
  },
  "audit.gipReport.export.startNotification": {
    "defaultMessage": "Export démarré"
  },
  "audit.gipReport.export.startNotificationError": {
    "defaultMessage": "Erreur lors du démarrage de l'export"
  },
  "audit.gipReport.export.title": {
    "defaultMessage": "Export"
  },
  "audit.gipReport.export.xlsConfig": {
    "defaultMessage": "Configuration XLS"
  },
  "audit.gipReport.exportModal.createdNotificationError": {
    "defaultMessage": "Erreur lors de la création du rapport"
  },
  "audit.gipReport.form.advertisers": {
    "defaultMessage": "Annonceurs"
  },
  "audit.gipReport.form.allAdvertisers": {
    "defaultMessage": "Tous les annonceurs"
  },
  "audit.gipReport.form.allCampaigns": {
    "defaultMessage": "Toutes les campagnes"
  },
  "audit.gipReport.form.allOrders": {
    "defaultMessage": "Toutes les commandes"
  },
  "audit.gipReport.form.allStationsDefault": {
    "defaultMessage": "Toutes les radios"
  },
  "audit.gipReport.form.allVersions": {
    "defaultMessage": "All versions"
  },
  "audit.gipReport.form.campaigns": {
    "defaultMessage": "Campagnes"
  },
  "audit.gipReport.form.customField": {
    "defaultMessage": "Custom field"
  },
  "audit.gipReport.form.customFieldValue": {
    "defaultMessage": "Custom field"
  },
  "audit.gipReport.form.customIds": {
    "defaultMessage": "Custom ID"
  },
  "audit.gipReport.form.endDate": {
    "defaultMessage": "End date"
  },
  "audit.gipReport.form.endTime": {
    "defaultMessage": "End time"
  },
  "audit.gipReport.form.loadOrderParams": {
    "defaultMessage": "Charger les paramètres de commande"
  },
  "audit.gipReport.form.loadOrderParamsMultiple": {
    "defaultMessage": "Charger les paramètres des commandes"
  },
  "audit.gipReport.form.orders": {
    "defaultMessage": "Commandes"
  },
  "audit.gipReport.form.selectCustom": {
    "defaultMessage": "Sélectionner personnalisé"
  },
  "audit.gipReport.form.startDate": {
    "defaultMessage": "Start date"
  },
  "audit.gipReport.form.startTime": {
    "defaultMessage": "Start time"
  },
  "audit.gipReport.form.stations": {
    "defaultMessage": "Stations"
  },
  "audit.gipReport.form.typeToSearch": {
    "defaultMessage": "Entrez au moins 2 caractères"
  },
  "audit.gipReport.form.versions": {
    "defaultMessage": "Versions"
  },
  "audit.gipReport.includeAllMatches": {
    "defaultMessage": "Inclure tous les matches trouvés dans l'export"
  },
  "audit.gipReport.info.createBtn": {
    "defaultMessage": "Save report"
  },
  "audit.gipReport.info.end": {
    "defaultMessage": "End date/time"
  },
  "audit.gipReport.info.start": {
    "defaultMessage": "Start date/time"
  },
  "audit.gipReport.noCustomFieldFilter": {
    "defaultMessage": "Aucun filtre de champ personnalisé"
  },
  "audit.gipReport.result.advertiser": {
    "defaultMessage": "Annonceur"
  },
  "audit.gipReport.result.campaign": {
    "defaultMessage": "Campagne"
  },
  "audit.gipReport.result.contract": {
    "defaultMessage": "Contrat"
  },
  "audit.gipReport.result.date": {
    "defaultMessage": "Date"
  },
  "audit.gipReport.result.dateTime": {
    "defaultMessage": "Date et heure"
  },
  "audit.gipReport.result.duration": {
    "defaultMessage": "Durée"
  },
  "audit.gipReport.result.matchDateTime": {
    "defaultMessage": "Date et heure de match"
  },
  "audit.gipReport.result.material.missing": {
    "defaultMessage": "Matériel {customId} manquant"
  },
  "audit.gipReport.result.order": {
    "defaultMessage": "Commande"
  },
  "audit.gipReport.result.schedule": {
    "defaultMessage": "Planning"
  },
  "audit.gipReport.result.showOffTolerance": {
    "defaultMessage": "Afficher hors tolérance"
  },
  "audit.gipReport.result.station": {
    "defaultMessage": "Station"
  },
  "audit.gipReport.result.tabs.future": {
    "defaultMessage": "À venir"
  },
  "audit.gipReport.result.tabs.long.future": {
    "defaultMessage": "Schedules à venir"
  },
  "audit.gipReport.result.tabs.long.missingMaterials": {
    "defaultMessage": "Schedules avec matériels manquants"
  },
  "audit.gipReport.result.tabs.long.toBeProcessed": {
    "defaultMessage": "Schedules à traiter"
  },
  "audit.gipReport.result.tabs.long.withMatches": {
    "defaultMessage": "Schedules avec matches"
  },
  "audit.gipReport.result.tabs.long.withoutMatches": {
    "defaultMessage": "Schedules sans matches"
  },
  "audit.gipReport.result.tabs.missingMaterials": {
    "defaultMessage": "Matériels manquants"
  },
  "audit.gipReport.result.tabs.toBeProcessed": {
    "defaultMessage": "À traiter"
  },
  "audit.gipReport.result.tabs.withMatches": {
    "defaultMessage": "Avec matches"
  },
  "audit.gipReport.result.tabs.withoutMatches": {
    "defaultMessage": "Sans matches"
  },
  "audit.gipReport.result.type": {
    "defaultMessage": "Type"
  },
  "audit.gipReport.result.version": {
    "defaultMessage": "Version"
  },
  "audit.gipReport.resultOptions": {
    "defaultMessage": "Options de résultats"
  },
  "audit.gipReport.title": {
    "defaultMessage": "Rapport GIP"
  },
  "audit.globalMissingAudios.groupByHelp.groupByCustomId": {
    "defaultMessage": "Grouper par <b>ID personnalisé</b> : les plannings sont groupés par ID personnalisé, un seul planning par audio manquant pour chacune des radios sélectionnées."
  },
  "audit.globalMissingAudios.groupByHelp.groupByCustomIdAndRadio": {
    "defaultMessage": "Grouper par <b>ID personnalisé et radio</b> : retourne un seul planning pour chaque station et chaque ID personnalisé."
  },
  "audit.globalMissingAudios.groupByHelp.intro": {
    "defaultMessage": "Cette option permet de grouper les plannings sans audio trouvé :"
  },
  "audit.globalMissingAudios.groupByHelp.noGroup": {
    "defaultMessage": "<b>Ne pas grouper</b> : retourne tous les plannings trouvés. Il peut y avoir plusieurs plannings avec le même ID personnalisé."
  },
  "audit.globalReports.title": {
    "defaultMessage": "Reportes globales"
  },
  "audit.liveMention.badge": {
    "defaultMessage": "Mention en direct"
  },
  "audit.liveMentions.acceptMention": {
    "defaultMessage": "Accept mention"
  },
  "audit.liveMentions.created": {
    "defaultMessage": "Mention manuelle créée"
  },
  "audit.liveMentions.createError": {
    "defaultMessage": "Mention non créée, réessayez"
  },
  "audit.liveMentions.mentionMatch": {
    "defaultMessage": "Mention Match"
  },
  "audit.liveMentions.processingMessage": {
    "defaultMessage": "Live mentions are being processed. Results will be available shortly."
  },
  "audit.liveMentions.rejectConfirm": {
    "defaultMessage": "Confirmer le rejet"
  },
  "audit.liveMentions.rejected": {
    "defaultMessage": "Mention rejetée"
  },
  "audit.liveMentions.rejectMention": {
    "defaultMessage": "Reject mention"
  },
  "audit.liveMentions.selectFromSchedules": {
    "defaultMessage": "Sélectionner une mention depuis les plannings"
  },
  "audit.liveMentions.status.ACCEPTED": {
    "defaultMessage": "Acceptée"
  },
  "audit.liveMentions.status.AUTO": {
    "defaultMessage": "Auto"
  },
  "audit.liveMentions.status.MANUAL": {
    "defaultMessage": "Manuel"
  },
  "audit.liveMentions.status.REJECTED": {
    "defaultMessage": "Rejetée"
  },
  "audit.liveMentionsAdd.createCustomMention": {
    "defaultMessage": "Créer une mention personnalisée"
  },
  "audit.liveMentionsAdd.mentionFromSchedules": {
    "defaultMessage": "Mention depuis les plannings"
  },
  "audit.liveMentionsAdd.title": {
    "defaultMessage": "Ajouter une mention en direct"
  },
  "audit.liveMentionsScreen.noResults": {
    "defaultMessage": "No results found"
  },
  "audit.lowerthird.duration": {
    "defaultMessage": "Duration"
  },
  "audit.lowerthird.title": {
    "defaultMessage": "Lowerthird"
  },
  "audit.lowerthirdScreen.loading": {
    "defaultMessage": "Chargement des lower thirds"
  },
  "audit.lowerthirdScreen.noResults": {
    "defaultMessage": "Aucun lower third trouvé"
  },
  "audit.ltxMatchesReport.emptyState.help": {
    "defaultMessage": "Compare les logs LTX importés avec les matches du système pour le jour sélectionné. Permet de vérifier quelles diffusions du log externe ont été confirmées et lesquelles ne l'ont pas été."
  },
  "audit.matchCategory.adOverlays": {
    "defaultMessage": "Overlays publicitaires"
  },
  "audit.matchCategory.customAds": {
    "defaultMessage": "Annonces personnalisées"
  },
  "audit.matchCategory.mentions": {
    "defaultMessage": "Mentions"
  },
  "audit.matches.spotMatch": {
    "defaultMessage": "Spot Match"
  },
  "audit.matchesAdd.created": {
    "defaultMessage": "Correspondance créée"
  },
  "audit.matchesAdd.createError": {
    "defaultMessage": "Erreur lors de la création de la correspondance"
  },
  "audit.matchesAdd.playedDuration": {
    "defaultMessage": "Durée jouée"
  },
  "audit.matchesAdd.title": {
    "defaultMessage": "Ajouter une correspondance"
  },
  "audit.matchesAdd.useAudioDuration": {
    "defaultMessage": "Utiliser la durée audio"
  },
  "audit.matchesScreen.downloadBtn": {
    "defaultMessage": "Télécharger le média"
  },
  "audit.matchesScreen.showOnStreamBtn": {
    "defaultMessage": "Afficher sur le flux"
  },
  "audit.matchesScreen.title": {
    "defaultMessage": "Matches"
  },
  "audit.mediaPlayer.viewMedia": {
    "defaultMessage": "Lire le média"
  },
  "audit.missingAudios.emptyState.help": {
    "defaultMessage": "Liste les IDs de matériel pour les schedules de la plage sélectionnée dont le média de référence n'a pas été chargé pour la station liée. Utile pour trouver des schedules sans média à détecter."
  },
  "audit.missingAudios.groupBy.custom_id": {
    "defaultMessage": "Custom ID"
  },
  "audit.missingAudios.groupBy.custom_id_station_id": {
    "defaultMessage": "Custom ID et station"
  },
  "audit.missingAudios.groupBy.none": {
    "defaultMessage": "Ne pas grouper"
  },
  "audit.missingAudios.scheduleDatetime": {
    "defaultMessage": "Schedule datetime"
  },
  "audit.missingAudios.title": {
    "defaultMessage": "Audios faltantes"
  },
  "audit.missingAudios.viewScheduleBtn": {
    "defaultMessage": "Voir les détails du planning"
  },
  "audit.noMatchesReport.emptyState.help": {
    "defaultMessage": "Affiche les fichiers média chargés dans l'intervalle sélectionné pour lesquels aucun match n'a été détecté dans cet intervalle ou dans l'autre intervalle ajusté."
  },
  "audit.notEnabled.htmlTitle": {
    "defaultMessage": "{stationName} - Audit non activé"
  },
  "audit.notEnabledForStation.body": {
    "defaultMessage": "Contactez-nous pour activer l'Audit pour {stationName}."
  },
  "audit.notEnabledForStation.title": {
    "defaultMessage": "Cette fonctionnalité n'est pas activée pour cette station"
  },
  "audit.preview.generating": {
    "defaultMessage": "Génération..."
  },
  "audit.preview.preview": {
    "defaultMessage": "Aperçu"
  },
  "audit.preview.previewCsv": {
    "defaultMessage": "Aperçu CSV"
  },
  "audit.preview.previewXls": {
    "defaultMessage": "Aperçu XLS"
  },
  "audit.props.advertiser": {
    "defaultMessage": "Advertiser"
  },
  "audit.props.audioDuration": {
    "defaultMessage": "Durée audio"
  },
  "audit.props.campaign": {
    "defaultMessage": "Campagne"
  },
  "audit.props.creationRange": {
    "defaultMessage": "Audio creation date range"
  },
  "audit.props.customId": {
    "defaultMessage": "ID personnalisé"
  },
  "audit.props.datetime": {
    "defaultMessage": "Target datetime"
  },
  "audit.props.duration": {
    "defaultMessage": "Played duration"
  },
  "audit.props.manualMatch": {
    "defaultMessage": "Match manuel"
  },
  "audit.props.matches": {
    "defaultMessage": "Matches"
  },
  "audit.props.mentionId": {
    "defaultMessage": "ID de la mention"
  },
  "audit.props.order": {
    "defaultMessage": "Commande"
  },
  "audit.props.score": {
    "defaultMessage": "Score"
  },
  "audit.props.time": {
    "defaultMessage": "Time"
  },
  "audit.props.tolerance": {
    "defaultMessage": "Tolérance"
  },
  "audit.props.tolerance.help": {
    "defaultMessage": "Les valeurs sont en minutes. Format : minutes avant / minutes après la date et l'heure programmées."
  },
  "audit.props.type": {
    "defaultMessage": "Type"
  },
  "audit.props.version": {
    "defaultMessage": "Version"
  },
  "audit.report.created": {
    "defaultMessage": "Created"
  },
  "audit.report.name": {
    "defaultMessage": "Name"
  },
  "audit.reportDefinitionEditor.columnLabel": {
    "defaultMessage": "Titre"
  },
  "audit.reportDefinitionEditor.columnType.boolean": {
    "defaultMessage": "Booléen"
  },
  "audit.reportDefinitionEditor.columnType.boolean.falseLabel": {
    "defaultMessage": "Étiquette pour faux"
  },
  "audit.reportDefinitionEditor.columnType.boolean.trueLabel": {
    "defaultMessage": "Étiquette pour vrai"
  },
  "audit.reportDefinitionEditor.columnType.date": {
    "defaultMessage": "Date"
  },
  "audit.reportDefinitionEditor.columnType.date.format": {
    "defaultMessage": "Format de date"
  },
  "audit.reportDefinitionEditor.columnType.datetime": {
    "defaultMessage": "Date et heure"
  },
  "audit.reportDefinitionEditor.columnType.datetime.format": {
    "defaultMessage": "Format date et heure"
  },
  "audit.reportDefinitionEditor.columnType.number": {
    "defaultMessage": "Nombre"
  },
  "audit.reportDefinitionEditor.columnType.string": {
    "defaultMessage": "Texte"
  },
  "audit.reportDefinitionEditor.columnType.string.case": {
    "defaultMessage": "Format du texte"
  },
  "audit.reportDefinitionEditor.columnType.string.case.lowercase": {
    "defaultMessage": "Minuscules"
  },
  "audit.reportDefinitionEditor.columnType.string.case.none": {
    "defaultMessage": "Sans format"
  },
  "audit.reportDefinitionEditor.columnType.string.case.title": {
    "defaultMessage": "Titre"
  },
  "audit.reportDefinitionEditor.columnType.string.case.uppercase": {
    "defaultMessage": "Majuscules"
  },
  "audit.reportDefinitionEditor.columnType.time": {
    "defaultMessage": "Heure"
  },
  "audit.reportDefinitionEditor.columnType.time.format": {
    "defaultMessage": "Format de l'heure"
  },
  "audit.reportDefinitionEditor.columnType.unknown": {
    "defaultMessage": "Inconnu"
  },
  "audit.reportDefinitionEditor.columnType.url": {
    "defaultMessage": "URL"
  },
  "audit.reportDefinitionEditor.metadata.default": {
    "defaultMessage": "Modèle par défaut"
  },
  "audit.reportDefinitionEditor.metadata.name": {
    "defaultMessage": "Nom"
  },
  "audit.reportDefinitionEditor.metadata.name.helper": {
    "defaultMessage": "Nom pour identifier ce modèle"
  },
  "audit.reportDefinitionEditor.metadata.title": {
    "defaultMessage": "Informations"
  },
  "audit.reportDefinitionEditor.title": {
    "defaultMessage": "Modèle de rapport"
  },
  "audit.reportDefinitionList.actions": {
    "defaultMessage": "Actions"
  },
  "audit.reportDefinitionList.createdAt": {
    "defaultMessage": "Créé"
  },
  "audit.reportDefinitionList.defaultTemplate": {
    "defaultMessage": "Modèle par défaut"
  },
  "audit.reportDefinitionList.editTooltip": {
    "defaultMessage": "Modifier"
  },
  "audit.reportDefinitionList.name": {
    "defaultMessage": "Nom"
  },
  "audit.reportDefinitionList.nameFilterPlaceholder": {
    "defaultMessage": "Rechercher par nom"
  },
  "audit.reportDefinitionList.title": {
    "defaultMessage": "Modèles de rapport"
  },
  "audit.reportDefinitions.availableColumns.empty": {
    "defaultMessage": "Aucune colonne disponible"
  },
  "audit.reportDefinitions.cannotDeleteDefault": {
    "defaultMessage": "Le modèle par défaut ne peut pas être supprimé"
  },
  "audit.reportDefinitions.cloneButton": {
    "defaultMessage": "Cloner"
  },
  "audit.reportDefinitions.cloneError": {
    "defaultMessage": "Erreur lors du clonage du modèle"
  },
  "audit.reportDefinitions.cloneSuccess": {
    "defaultMessage": "Modèle cloné avec succès"
  },
  "audit.reportDefinitions.createError": {
    "defaultMessage": "Erreur lors de la création du modèle"
  },
  "audit.reportDefinitions.deleteError": {
    "defaultMessage": "Erreur lors de la suppression du modèle"
  },
  "audit.reportDefinitions.deleteSuccess": {
    "defaultMessage": "Modèle supprimé avec succès"
  },
  "audit.reportDefinitions.deleteTemplateConfirm": {
    "defaultMessage": "Êtes-vous sûr de vouloir supprimer le modèle \"{name}\" ? Cette action est irréversible."
  },
  "audit.reportDefinitions.deleteTemplateTitle": {
    "defaultMessage": "Supprimer le modèle"
  },
  "audit.reportDefinitions.loadCustomLogo": {
    "defaultMessage": "Charger le logo personnalisé"
  },
  "audit.reportDefinitions.newTemplateButton": {
    "defaultMessage": "Nouveau modèle"
  },
  "audit.reportDefinitions.previewError": {
    "defaultMessage": "Erreur lors de la génération de l'aperçu"
  },
  "audit.reportDefinitions.reportTemplateTitle": {
    "defaultMessage": "Modèle de rapport"
  },
  "audit.reportDefinitions.reportTypeRequired": {
    "defaultMessage": "Le type de rapport est requis"
  },
  "audit.reportDefinitions.saveError": {
    "defaultMessage": "Erreur lors de l'enregistrement du modèle de rapport"
  },
  "audit.reportDefinitions.saveSuccess": {
    "defaultMessage": "Modèle de rapport enregistré avec succès"
  },
  "audit.reportDefinitions.segmentation.groupBy": {
    "defaultMessage": "Colonne"
  },
  "audit.reportDefinitions.segmentation.grouping": {
    "defaultMessage": "Segmentation"
  },
  "audit.reportDefinitions.segmentation.helperText": {
    "defaultMessage": "Dans les fichiers XLS, une feuille sera générée pour chaque valeur du champ sélectionné. Dans les fichiers CSV, un fichier distinct sera généré dans un .zip"
  },
  "audit.reportDefinitions.segmentation.hideColumn": {
    "defaultMessage": "Masquer cette colonne dans le rapport"
  },
  "audit.reportDefinitions.segmentation.noColumns": {
    "defaultMessage": "Vous devez sélectionner au moins une colonne pour pouvoir grouper."
  },
  "audit.reportDefinitions.segmentation.removedNotification": {
    "defaultMessage": "La segmentation a été désactivée car la colonne associée a été retirée."
  },
  "audit.reportDefinitions.segmentation.splitReport": {
    "defaultMessage": "Diviser en sections pour l'une des colonnes"
  },
  "audit.reportDefinitions.segmentation.tour.description": {
    "defaultMessage": "Activez cette option pour diviser le rapport en sections (ex. une feuille XLS par valeur de la colonne choisie). Vous pouvez choisir la colonne et la masquer dans le résultat si besoin."
  },
  "audit.reportDefinitions.segmentation.tour.title": {
    "defaultMessage": "Segmentation du rapport"
  },
  "audit.reportDefinitions.selectedColumns.empty": {
    "defaultMessage": "Aucune colonne sélectionnée. Utilisez le bouton flèche sur les colonnes disponibles pour les ajouter."
  },
  "audit.reportDefinitions.sorting.noRules": {
    "defaultMessage": "Aucune règle de tri. Cliquez sur \"Ajouter un ordre\" pour en ajouter une."
  },
  "audit.reportDefinitions.sorting.order": {
    "defaultMessage": "Ordre"
  },
  "audit.reportDefinitions.styleTitle": {
    "defaultMessage": "Style"
  },
  "audit.reportDefinitions.templatesForReport": {
    "defaultMessage": "Modèles pour le report {name}"
  },
  "audit.reportDefinitions.templatesTitle": {
    "defaultMessage": "Modèles"
  },
  "audit.reportDefinitions.useClientLogo": {
    "defaultMessage": "Utiliser le logo du client"
  },
  "audit.reportDelete.deleted": {
    "defaultMessage": "Report deleted"
  },
  "audit.reportDelete.deleteError": {
    "defaultMessage": "Could not delete report"
  },
  "audit.reportDelete.prompt": {
    "defaultMessage": "Do you want to delete this report? {br} This action can not be undone."
  },
  "audit.reportDelete.title": {
    "defaultMessage": "Supprimer le rapport"
  },
  "audit.reportNames.AUDIT_BROADCAST_EVIDENCE": {
    "defaultMessage": "Preuve de diffusion"
  },
  "audit.reportNames.AUDIT_GIP_ALTERNATIVE_REPORT": {
    "defaultMessage": "GIP alternatif"
  },
  "audit.reportNames.AUDIT_GIP_STATUS": {
    "defaultMessage": "GIP"
  },
  "audit.reportNames.BCR_MATCHES": {
    "defaultMessage": "BCR Matches"
  },
  "audit.reports.bcrMatches.noBcrEntries": {
    "defaultMessage": "Aucune entrée BCR trouvée pour le rapport"
  },
  "audit.reports.branding.logo": {
    "defaultMessage": "Logo"
  },
  "audit.reports.ltxMatches.noLtxEntries": {
    "defaultMessage": "Aucune entrée LTX trouvée pour le rapport"
  },
  "audit.reports.section.availableColumns": {
    "defaultMessage": "Colonnes disponibles"
  },
  "audit.reports.section.reportColumns": {
    "defaultMessage": "Colonnes du rapport"
  },
  "audit.reports.sorting.add": {
    "defaultMessage": "Ajouter"
  },
  "audit.reports.viewNotFound": {
    "defaultMessage": "Vue introuvable pour le rapport {type}"
  },
  "audit.reportsList.createdBy": {
    "defaultMessage": "Créé par"
  },
  "audit.reportsList.exportStatus": {
    "defaultMessage": "Statut d'export"
  },
  "audit.reportsList.noExport": {
    "defaultMessage": "Aucun export"
  },
  "audit.reportsList.onlyMine": {
    "defaultMessage": "Seulement les miens"
  },
  "audit.reportsList.title": {
    "defaultMessage": "Created reports"
  },
  "audit.reportsScreen.bcrMatches.customId": {
    "defaultMessage": "Custom ID (optionnel)"
  },
  "audit.reportsScreen.bcrMatches.date": {
    "defaultMessage": "Date"
  },
  "audit.reportsScreen.bcrMatches.noSchedule": {
    "defaultMessage": "Sans schedule"
  },
  "audit.reportsScreen.bcrMatches.tabs.unverifiedBcrEntries": {
    "defaultMessage": "Entrées BCR non vérifiées"
  },
  "audit.reportsScreen.bcrMatches.tabs.unverifiedMatches": {
    "defaultMessage": "Matches non vérifiés"
  },
  "audit.reportsScreen.bcrMatches.tabs.verified": {
    "defaultMessage": "Matches vérifiés"
  },
  "audit.reportsScreen.bcrMatches.title": {
    "defaultMessage": "BCR Matches"
  },
  "audit.reportsScreen.bcrMatches.unverifiedBcrEntries.name": {
    "defaultMessage": "Nom"
  },
  "audit.reportsScreen.bcrMatches.verified.bcrEntryDatetime": {
    "defaultMessage": "Heure d'entrée BCR"
  },
  "audit.reportsScreen.bcrMatches.verified.bcrName": {
    "defaultMessage": "Nom BCR"
  },
  "audit.reportsScreen.bcrMatches.verified.matchedSchedule": {
    "defaultMessage": "Schedule"
  },
  "audit.reportsScreen.equalMd5.title": {
    "defaultMessage": "Audios with same content"
  },
  "audit.reportsScreen.ltxMatches.customId": {
    "defaultMessage": "Custom ID (optionnel)"
  },
  "audit.reportsScreen.ltxMatches.date": {
    "defaultMessage": "Date"
  },
  "audit.reportsScreen.ltxMatches.noSchedule": {
    "defaultMessage": "Sans schedule"
  },
  "audit.reportsScreen.ltxMatches.tabs.unverifiedLtxEntries": {
    "defaultMessage": "Entrées LTX non vérifiées"
  },
  "audit.reportsScreen.ltxMatches.tabs.unverifiedMatches": {
    "defaultMessage": "Matches non vérifiés"
  },
  "audit.reportsScreen.ltxMatches.tabs.verified": {
    "defaultMessage": "Matches vérifiés"
  },
  "audit.reportsScreen.ltxMatches.title": {
    "defaultMessage": "LTX Matches"
  },
  "audit.reportsScreen.ltxMatches.unverifiedLtxEntries.name": {
    "defaultMessage": "Nom"
  },
  "audit.reportsScreen.ltxMatches.unverifiedLtxEntries.type": {
    "defaultMessage": "Type"
  },
  "audit.reportsScreen.ltxMatches.verified.ltxEntryDatetime": {
    "defaultMessage": "Heure d'entrée LTX"
  },
  "audit.reportsScreen.ltxMatches.verified.ltxName": {
    "defaultMessage": "Nom LTX"
  },
  "audit.reportsScreen.ltxMatches.verified.matchedSchedule": {
    "defaultMessage": "Schedule"
  },
  "audit.reportsScreen.missingAudios.datetime": {
    "defaultMessage": "Date/heure"
  },
  "audit.reportsScreen.missingAudios.title": {
    "defaultMessage": "Missing audios"
  },
  "audit.reportsScreen.missingAudios.viewScheduleBtn": {
    "defaultMessage": "View schedule detail"
  },
  "audit.reportsScreen.noMatches.creationRange": {
    "defaultMessage": "Plage de création"
  },
  "audit.reportsScreen.noMatches.matchRange": {
    "defaultMessage": "Match range"
  },
  "audit.reportsScreen.noMatches.sameAudioMatch.matchesLink": {
    "defaultMessage": "View {audioId} matches"
  },
  "audit.reportsScreen.noMatches.sameAudioMatch.message": {
    "defaultMessage": "There is an equal-content audio with matches:"
  },
  "audit.reportsScreen.noMatches.title": {
    "defaultMessage": "Fichiers sans matches"
  },
  "audit.reportsScreen.noMatches.useSameRangeLabel": {
    "defaultMessage": "Use same audio creation range"
  },
  "audit.reportsScreen.title": {
    "defaultMessage": "Reports"
  },
  "audit.reportsView.cloneBtn": {
    "defaultMessage": "Cloner"
  },
  "audit.reportsView.created": {
    "defaultMessage": "Créé"
  },
  "audit.reportsView.createdBy": {
    "defaultMessage": "Créé par"
  },
  "audit.reportsView.createdByUnknown": {
    "defaultMessage": "Créé par inconnu"
  },
  "audit.reportsView.export": {
    "defaultMessage": "Exporter"
  },
  "audit.reportsView.exportBtn": {
    "defaultMessage": "Télécharger le rapport"
  },
  "audit.reportsView.exportDialog.confirm": {
    "defaultMessage": "Télécharger"
  },
  "audit.reportsView.exportDialog.format": {
    "defaultMessage": "Format"
  },
  "audit.reportsView.exportDialog.noDefinitions": {
    "defaultMessage": "Aucun modèle disponible"
  },
  "audit.reportsView.exportDialog.title": {
    "defaultMessage": "Télécharger le rapport"
  },
  "audit.reportsView.exportFailed": {
    "defaultMessage": "Export échoué"
  },
  "audit.reportsView.exportInfo": {
    "defaultMessage": "Configuration d'export"
  },
  "audit.reportsView.name": {
    "defaultMessage": "Nom"
  },
  "audit.reportsView.type": {
    "defaultMessage": "Type"
  },
  "audit.schedulesList.matchDatetime": {
    "defaultMessage": "Match"
  },
  "audit.schedulesList.mentions.diffLabel": {
    "defaultMessage": "Diff"
  },
  "audit.schedulesListScreen.inheritedTolerance": {
    "defaultMessage": "Tolérance héritée"
  },
  "audit.schedulesListScreen.noAudio": {
    "defaultMessage": "No audio"
  },
  "audit.schedulesListScreen.noMatch": {
    "defaultMessage": "Aucune correspondance"
  },
  "audit.schedulesListScreen.props.status": {
    "defaultMessage": "Status"
  },
  "audit.schedulesListScreen.title": {
    "defaultMessage": "Schedules"
  },
  "audit.schedulesListScreen.viewScheduleBtn": {
    "defaultMessage": "View detail"
  },
  "audit.schedulesNoMatches.includeMissingAudio": {
    "defaultMessage": "Inclure les audios manquants"
  },
  "audit.schedulesNoMatches.title": {
    "defaultMessage": "Schedules sans matches"
  },
  "audit.schedulesPreview.advertiser": {
    "defaultMessage": "Annonceur"
  },
  "audit.schedulesPreview.campaign": {
    "defaultMessage": "Campagne"
  },
  "audit.schedulesPreview.dateTime": {
    "defaultMessage": "Date/heure"
  },
  "audit.schedulesPreview.tolerance": {
    "defaultMessage": "Tolérance"
  },
  "audit.schedulesPreview.version": {
    "defaultMessage": "Version"
  },
  "audit.scheduleStatusPntScreen.confidence": {
    "defaultMessage": "Confiance"
  },
  "audit.scheduleStatusPntScreen.status.help": {
    "defaultMessage": "Les nombres indiquent matches avec schedule / schedules.\n\nComplet : chaque schedule a un match.\nPartiel : tous les schedules n'ont pas de match.\nSans diffusion : il y a des schedules et aucun match.\nSans matches : il n'y a ni matches ni schedules.\n\nL'icône d'avertissement indique qu'au moins un match est hors tolérance."
  },
  "audit.scheduleStatusScreen.detailModal.matchDatetime": {
    "defaultMessage": "Date/heure de correspondance"
  },
  "audit.scheduleStatusScreen.detailModal.matchedSchedule": {
    "defaultMessage": "Matched schedule"
  },
  "audit.scheduleStatusScreen.detailModal.matches": {
    "defaultMessage": "Match confirmé"
  },
  "audit.scheduleStatusScreen.detailModal.noMatchedSchedule": {
    "defaultMessage": "Sans schedule"
  },
  "audit.scheduleStatusScreen.detailModal.offTolerance": {
    "defaultMessage": "Hors tolérance"
  },
  "audit.scheduleStatusScreen.detailModal.schedules": {
    "defaultMessage": "Schedules"
  },
  "audit.scheduleStatusScreen.detailModal.unmatchedMatches": {
    "defaultMessage": "Matches sans schedule"
  },
  "audit.scheduleStatusScreen.filter.idPlaceholder": {
    "defaultMessage": "All"
  },
  "audit.scheduleStatusScreen.noAudio": {
    "defaultMessage": "Aucun audio"
  },
  "audit.scheduleStatusScreen.overview.all": {
    "defaultMessage": "Tous"
  },
  "audit.scheduleStatusScreen.status": {
    "defaultMessage": "État"
  },
  "audit.scheduleStatusScreen.status.chipTooltip": {
    "defaultMessage": "{matchesCount} matches / {matchesWithScheduleCount} avec schedule / {schedulesCount} schedules"
  },
  "audit.scheduleStatusScreen.status.chipTooltipOffTolerance": {
    "defaultMessage": "{matchesCount} matches / {matchesWithScheduleCount} avec schedule / {schedulesCount} schedules ({offToleranceCount} hors tolérance)"
  },
  "audit.scheduleStatusScreen.status.complete": {
    "defaultMessage": "Complet"
  },
  "audit.scheduleStatusScreen.status.help": {
    "defaultMessage": "Les nombres indiquent matches avec schedule / schedules.\n\nComplet : chaque schedule a un match.\nPartiel : tous les schedules n'ont pas de match.\nSans diffusion : il y a des schedules et aucun match.\nSans matches : il n'y a ni matches ni schedules.\n\nL'icône d'avertissement indique qu'au moins un match est hors tolérance."
  },
  "audit.scheduleStatusScreen.status.missingEmission": {
    "defaultMessage": "Sans diffusion"
  },
  "audit.scheduleStatusScreen.status.none": {
    "defaultMessage": "Sans matches"
  },
  "audit.scheduleStatusScreen.status.offTolerance": {
    "defaultMessage": "Hors tolérance"
  },
  "audit.scheduleStatusScreen.status.partial": {
    "defaultMessage": "Partiel"
  },
  "audit.scheduleStatusScreen.title": {
    "defaultMessage": "Schedule"
  },
  "audit.schedulesViewScreen.loading": {
    "defaultMessage": "Loading schedule"
  },
  "audit.schedulesViewScreen.matchDiff": {
    "defaultMessage": "Difference (minutes)"
  },
  "audit.schedulesViewScreen.matchesCount": {
    "defaultMessage": "{count, plural, =0 {No results found for the date} one {1 match found} other {# matches found} }"
  },
  "audit.schedulesViewScreen.matchTime": {
    "defaultMessage": "Date and time"
  },
  "audit.schedulesViewScreen.title": {
    "defaultMessage": "Schedule #{id}"
  },
  "audit.screenbug.title": {
    "defaultMessage": "Screenbug"
  },
  "audit.sidenav.aod": {
    "defaultMessage": "AOD"
  },
  "audit.sidenav.config": {
    "defaultMessage": "Config"
  },
  "audit.sidenav.globalReports": {
    "defaultMessage": "Global reports"
  },
  "audit.sidenav.stationAudit": {
    "defaultMessage": "Station audit"
  },
  "audit.sorting.ascending": {
    "defaultMessage": "Ascendant"
  },
  "audit.sorting.descending": {
    "defaultMessage": "Descendant"
  },
  "audit.streamScreen.adoverlay": {
    "defaultMessage": "Ad Overlay"
  },
  "audit.streamScreen.audioMatches": {
    "defaultMessage": "Audio Matches"
  },
  "audit.streamScreen.liveMentions": {
    "defaultMessage": "Live Mentions"
  },
  "audit.streamScreen.lowerthird": {
    "defaultMessage": "Lowerthird"
  },
  "audit.streamScreen.transcriptions": {
    "defaultMessage": "Transcriptions"
  },
  "audit.title": {
    "defaultMessage": "Audit"
  },
  "audit.transcriptionScreen.confidence": {
    "defaultMessage": "Confianza"
  },
  "audit.transcriptionScreen.high": {
    "defaultMessage": "Élevée"
  },
  "audit.transcriptionScreen.loading": {
    "defaultMessage": "Chargement des transcriptions"
  },
  "audit.transcriptionScreen.low": {
    "defaultMessage": "Faible"
  },
  "audit.transcriptionScreen.medium": {
    "defaultMessage": "Moyenne"
  },
  "audit.transcriptionScreen.music": {
    "defaultMessage": "[Music / Silence]"
  },
  "audit.transcriptionScreen.noResults": {
    "defaultMessage": "Aucune transcription trouvée"
  },
  "audit.transcriptionScreen.sentence": {
    "defaultMessage": "Sentence"
  },
  "audit.transcriptionScreen.speakers": {
    "defaultMessage": "Speaker Labels"
  },
  "audit.uploadScreen.item.code": {
    "defaultMessage": "(Error code: {code})"
  },
  "audit.uploadScreen.item.completed": {
    "defaultMessage": "Successfully uploaded"
  },
  "audit.uploadScreen.item.error": {
    "defaultMessage": "Erreur : {message}"
  },
  "audit.uploadScreen.item.notStarted": {
    "defaultMessage": "Not uploaded"
  },
  "audit.uploadScreen.item.overridden": {
    "defaultMessage": "(previous audio version was updated)"
  },
  "audit.uploadScreen.item.remove": {
    "defaultMessage": "Remove"
  },
  "audit.uploadScreen.item.started": {
    "defaultMessage": "Uploading"
  },
  "audit.uploadScreen.item.status": {
    "defaultMessage": "Statut :"
  },
  "audit.uploadScreen.leavePrompt": {
    "defaultMessage": "There is one or more uploads in progress. Are you sure you want to leave the page?"
  },
  "audit.uploadScreen.reset": {
    "defaultMessage": "Reset"
  },
  "audit.uploadScreen.selectedCount": {
    "defaultMessage": "{count, plural, one {1 selected file} other {# selected files} }"
  },
  "audit.uploadScreen.title": {
    "defaultMessage": "Téléverser des audios"
  },
  "audit.uploadScreen.upload": {
    "defaultMessage": "Upload"
  },
  "audit.verifyMatch.accept": {
    "defaultMessage": "Accepter"
  },
  "audit.verifyMatch.actionTitle": {
    "defaultMessage": "Vérifier la détection"
  },
  "audit.verifyMatch.broadcastTitle": {
    "defaultMessage": "Diffusion détectée"
  },
  "audit.verifyMatch.creativeTitle": {
    "defaultMessage": "Média de référence"
  },
  "audit.verifyMatch.dialogTitle": {
    "defaultMessage": "Vérifier la détection"
  },
  "audit.verifyMatch.mentionContentTitle": {
    "defaultMessage": "Contenu de la mention"
  },
  "audit.verifyMatch.navigationPosition": {
    "defaultMessage": "{current} / {total}"
  },
  "audit.verifyMatch.next": {
    "defaultMessage": "Suivant"
  },
  "audit.verifyMatch.noMentionContent": {
    "defaultMessage": "Aucun contenu de mention disponible pour cette détection."
  },
  "audit.verifyMatch.noScheduleConfirmation": {
    "defaultMessage": "Sans confirmation"
  },
  "audit.verifyMatch.noTranscription": {
    "defaultMessage": "Aucune transcription disponible pour ce media."
  },
  "audit.verifyMatch.previous": {
    "defaultMessage": "Précédent"
  },
  "audit.verifyMatch.reject": {
    "defaultMessage": "Rejeter"
  },
  "audit.verifyMatch.transcriptionTitle": {
    "defaultMessage": "Transcription du média"
  },
  "auth.errors.ERR_AUTH_FAILED": {
    "defaultMessage": "Veuillez réessayer ou contacter le support."
  },
  "auth.errors.ERR_USER_NOT_REGISTERED": {
    "defaultMessage": "L'utilisateur n'est pas enregistré sur la plateforme. Veuillez contacter le support."
  },
  "auth.loginScreen.errorTitle": {
    "defaultMessage": "Connexion impossible"
  },
  "auth.loginScreen.loginBtn": {
    "defaultMessage": "Se connecter"
  },
  "auth.loginScreen.title": {
    "defaultMessage": "Connexion"
  },
  "auth.noPermissionForPage": {
    "defaultMessage": "Vous n'avez pas la permission d'accéder à cette page"
  },
  "auth.tokenGate.errorLabel": {
    "defaultMessage": "Erreur d'auth. :"
  },
  "auth.userInfo.changeUser": {
    "defaultMessage": "Changer d'utilisateur"
  },
  "common.action.clear": {
    "defaultMessage": "Effacer"
  },
  "common.actions": {
    "defaultMessage": "Actions"
  },
  "common.actions.back": {
    "defaultMessage": "Retour"
  },
  "common.actions.cancel": {
    "defaultMessage": "Annuler"
  },
  "common.actions.clone": {
    "defaultMessage": "Cloner"
  },
  "common.actions.create": {
    "defaultMessage": "Créer nouveau"
  },
  "common.actions.createEntity": {
    "defaultMessage": "Créer"
  },
  "common.actions.delete": {
    "defaultMessage": "Supprimer"
  },
  "common.actions.discard": {
    "defaultMessage": "Abandonner"
  },
  "common.actions.draft": {
    "defaultMessage": "Brouillon"
  },
  "common.actions.edit": {
    "defaultMessage": "Modifier"
  },
  "common.actions.export": {
    "defaultMessage": "Exporter"
  },
  "common.actions.exportAsCsv": {
    "defaultMessage": "Exporter en CSV"
  },
  "common.actions.exportAsXls": {
    "defaultMessage": "Exporter en XLS"
  },
  "common.actions.filterByValue": {
    "defaultMessage": "Filtrer par cette valeur"
  },
  "common.actions.refresh": {
    "defaultMessage": "Actualiser"
  },
  "common.actions.resetFilters": {
    "defaultMessage": "Effacer"
  },
  "common.actions.save": {
    "defaultMessage": "Enregistrer"
  },
  "common.actions.select": {
    "defaultMessage": "Sélectionner..."
  },
  "common.actions.selectAll": {
    "defaultMessage": "Tout sélectionner"
  },
  "common.actions.selectNone": {
    "defaultMessage": "Tout désélectionner"
  },
  "common.allStations": {
    "defaultMessage": "Toutes les stations"
  },
  "common.audio": {
    "defaultMessage": "audio"
  },
  "common.breadcrumb": {
    "defaultMessage": "Fil d'Ariane"
  },
  "common.cancel": {
    "defaultMessage": "Annuler"
  },
  "common.clear": {
    "defaultMessage": "Effacer"
  },
  "common.close": {
    "defaultMessage": "Fermer"
  },
  "common.columnIndex": {
    "defaultMessage": "#"
  },
  "common.confirm": {
    "defaultMessage": "Confirmer"
  },
  "common.createdAt": {
    "defaultMessage": "Créé le"
  },
  "common.customId": {
    "defaultMessage": "ID personnalisé"
  },
  "common.customImage": {
    "defaultMessage": "Image personnalisée"
  },
  "common.date": {
    "defaultMessage": "Date"
  },
  "common.dateEnd": {
    "defaultMessage": "Date de fin"
  },
  "common.dateRangeSelector.apply": {
    "defaultMessage": "Appliquer"
  },
  "common.dateRangeSelector.labelToNow": {
    "defaultMessage": "{from} jusqu'à maintenant"
  },
  "common.dateRangeSelector.preset.customFixedDateRange": {
    "defaultMessage": "Plage de dates personnalisée..."
  },
  "common.dateRangeSelector.preset.customSingleDate": {
    "defaultMessage": "Date personnalisée..."
  },
  "common.dateRangeSelector.preset.fromCustomDateUntilNow": {
    "defaultMessage": "Depuis une date jusqu'à maintenant..."
  },
  "common.dateRangeSelector.preset.last14Days": {
    "defaultMessage": "14 derniers jours"
  },
  "common.dateRangeSelector.preset.last180Days": {
    "defaultMessage": "180 derniers jours"
  },
  "common.dateRangeSelector.preset.last24Hours": {
    "defaultMessage": "24 dernières heures"
  },
  "common.dateRangeSelector.preset.last30Days": {
    "defaultMessage": "30 derniers jours"
  },
  "common.dateRangeSelector.preset.last7Days": {
    "defaultMessage": "7 derniers jours"
  },
  "common.dateRangeSelector.preset.last90Days": {
    "defaultMessage": "90 derniers jours"
  },
  "common.dateRangeSelector.preset.lastHour": {
    "defaultMessage": "Dernière heure"
  },
  "common.dateRangeSelector.preset.lastMonth": {
    "defaultMessage": "Mois dernier"
  },
  "common.dateRangeSelector.preset.lastNHours": {
    "defaultMessage": "{hours} dernières heures"
  },
  "common.dateRangeSelector.preset.lastWeek": {
    "defaultMessage": "Semaine dernière"
  },
  "common.dateRangeSelector.preset.thisMonth": {
    "defaultMessage": "Ce mois"
  },
  "common.dateRangeSelector.preset.thisWeek": {
    "defaultMessage": "Cette semaine"
  },
  "common.dateRangeSelector.preset.today": {
    "defaultMessage": "Aujourd'hui"
  },
  "common.dateRangeSelector.preset.yearToDate": {
    "defaultMessage": "Depuis le début de l'année"
  },
  "common.dateRangeSelector.preset.yesterday": {
    "defaultMessage": "Hier"
  },
  "common.dateRangeSelector.selectDateRangeTitle": {
    "defaultMessage": "Sélectionner une plage de dates"
  },
  "common.dateRangeSelector.selectedLabel": {
    "defaultMessage": "Sélectionné : {from} – {to}"
  },
  "common.dateSelector.preset.dayMinus2": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.dayMinus3": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.dayMinus4": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.dayMinus5": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.dayMinus6": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.today": {
    "defaultMessage": "Aujourd'hui"
  },
  "common.dateSelector.preset.yesterday": {
    "defaultMessage": "Hier"
  },
  "common.dateSelector.selectDate": {
    "defaultMessage": "Sélectionner la date"
  },
  "common.dateStart": {
    "defaultMessage": "Date de début"
  },
  "common.datetime": {
    "defaultMessage": "Date et heure"
  },
  "common.datetimeRange": {
    "defaultMessage": "Plage de dates"
  },
  "common.delete": {
    "defaultMessage": "Supprimer"
  },
  "common.disabled": {
    "defaultMessage": "Désactivé"
  },
  "common.download": {
    "defaultMessage": "Télécharger"
  },
  "common.edit": {
    "defaultMessage": "Modifier"
  },
  "common.email": {
    "defaultMessage": "E-mail"
  },
  "common.enabled": {
    "defaultMessage": "Activé"
  },
  "common.entities.fragments": {
    "defaultMessage": "fragments"
  },
  "common.entities.group": {
    "defaultMessage": "Groupe"
  },
  "common.entities.groups": {
    "defaultMessage": "groupes"
  },
  "common.entities.station": {
    "defaultMessage": "Station"
  },
  "common.entities.stations": {
    "defaultMessage": "Stations"
  },
  "common.entities.user": {
    "defaultMessage": "utilisateur"
  },
  "common.error": {
    "defaultMessage": "Une erreur s'est produite, veuillez réessayer"
  },
  "common.errorOccurredTryAgain": {
    "defaultMessage": "Une erreur s'est produite, réessayez"
  },
  "common.form.errorNotification": {
    "defaultMessage": "Une erreur s'est produite. Veuillez vérifier tous les champs et réessayer. Si l'erreur persiste, contactez le support"
  },
  "common.form.saveBtnText": {
    "defaultMessage": "Enregistrer"
  },
  "common.frameSelector.frameSelected": {
    "defaultMessage": "Image sélectionnée :"
  },
  "common.frameSelector.useThisFrame": {
    "defaultMessage": "Utiliser cette image"
  },
  "common.groupBy": {
    "defaultMessage": "Grouper par"
  },
  "common.help": {
    "defaultMessage": "Aide"
  },
  "common.insertContentHere": {
    "defaultMessage": "Insérer le contenu ici"
  },
  "common.jobFailed": {
    "defaultMessage": "Échec du traitement"
  },
  "common.jobInProgress": {
    "defaultMessage": "Traitement en cours"
  },
  "common.jobStatus.CANCELLED": {
    "defaultMessage": "Annulé"
  },
  "common.jobStatus.COMPLETED": {
    "defaultMessage": "Terminé"
  },
  "common.jobStatus.FAILED": {
    "defaultMessage": "Échoué"
  },
  "common.jobStatus.IN_PROGRESS": {
    "defaultMessage": "En cours"
  },
  "common.jobStatus.SCHEDULED": {
    "defaultMessage": "Programmé"
  },
  "common.jobStatus.WAITING": {
    "defaultMessage": "En file d'attente"
  },
  "common.languageSelect.defaultLabel": {
    "defaultMessage": "Langue"
  },
  "common.listView.clearAllFilters": {
    "defaultMessage": "Effacer tous les filtres"
  },
  "common.listView.noMoreResults": {
    "defaultMessage": "No hay más resultados"
  },
  "common.listView.noResults": {
    "defaultMessage": "Aucun résultat"
  },
  "common.listView.totalResults": {
    "defaultMessage": "{count, number} résultats"
  },
  "common.listView.tryOtherFiltersOrClear": {
    "defaultMessage": "Essayez avec d'autres filtres ou supprimez ceux appliqués pour voir plus de résultats."
  },
  "common.listView.useFiltersToFindMore": {
    "defaultMessage": "Utilisez les filtres pour trouver plus de résultats"
  },
  "common.loadFile": {
    "defaultMessage": "Charger le fichier"
  },
  "common.loadImage": {
    "defaultMessage": "Charger l'image"
  },
  "common.loading": {
    "defaultMessage": "Chargement..."
  },
  "common.loadingEntity": {
    "defaultMessage": "Chargement de {entity}..."
  },
  "common.loadMore": {
    "defaultMessage": "Afficher les précédents"
  },
  "common.loadThumbnail": {
    "defaultMessage": "Charger la miniature"
  },
  "common.name": {
    "defaultMessage": "Nom"
  },
  "common.no": {
    "defaultMessage": "Non"
  },
  "common.noOptions": {
    "defaultMessage": "Aucun résultat trouvé"
  },
  "common.noResults": {
    "defaultMessage": "Aucun résultat"
  },
  "common.noStations.message": {
    "defaultMessage": "En attente..."
  },
  "common.noStations.title": {
    "defaultMessage": "Aucune station assignée pour le moment"
  },
  "common.notes": {
    "defaultMessage": "Notes"
  },
  "common.notifications.deleted": {
    "defaultMessage": "Supprimé avec succès"
  },
  "common.notifications.deleteError": {
    "defaultMessage": "Impossible de supprimer {entity}"
  },
  "common.notifications.updated": {
    "defaultMessage": "{entity} mis à jour"
  },
  "common.optional": {
    "defaultMessage": "(optionnel)"
  },
  "common.pause": {
    "defaultMessage": "Pause"
  },
  "common.play": {
    "defaultMessage": "Lire"
  },
  "common.prose.showLess": {
    "defaultMessage": "Afficher moins"
  },
  "common.prose.showMore": {
    "defaultMessage": "Afficher plus"
  },
  "common.quantity": {
    "defaultMessage": "Quantité"
  },
  "common.refresh": {
    "defaultMessage": "Actualiser"
  },
  "common.remove": {
    "defaultMessage": "Supprimer"
  },
  "common.removeFilter": {
    "defaultMessage": "Supprimer le filtre"
  },
  "common.required": {
    "defaultMessage": "Requis"
  },
  "common.routeNotFound.help": {
    "defaultMessage": "Le lien est peut-être rompu ou la page a été déplacée."
  },
  "common.routeNotFound.title": {
    "defaultMessage": "Cette page n'existe pas"
  },
  "common.selectFileLabel": {
    "defaultMessage": "Sélectionner le fichier {extensions}"
  },
  "common.show": {
    "defaultMessage": "Afficher"
  },
  "common.simpleTableAriaLabel": {
    "defaultMessage": "Tableau de données"
  },
  "common.station": {
    "defaultMessage": "Station"
  },
  "common.stationNotFound.help": {
    "defaultMessage": "Elle n'existe peut-être pas ou vous n'y avez peut-être pas accès."
  },
  "common.stationNotFound.text": {
    "defaultMessage": "Station non trouvée"
  },
  "common.stations": {
    "defaultMessage": "Stations"
  },
  "common.stations.shared.tooltip": {
    "defaultMessage": "Station externe"
  },
  "common.stations.type.AFFILIATE": {
    "defaultMessage": "Affiliée"
  },
  "common.stations.type.HEADER": {
    "defaultMessage": "En-tête"
  },
  "common.stations.type.REPEATER": {
    "defaultMessage": "Relais"
  },
  "common.stations.type.STANDALONE": {
    "defaultMessage": "Autonome"
  },
  "common.stations.youtubeNative.tooltip": {
    "defaultMessage": "Station native YouTube"
  },
  "common.status": {
    "defaultMessage": "Statut"
  },
  "common.status.active": {
    "defaultMessage": "Active"
  },
  "common.status.inactive": {
    "defaultMessage": "Inactive"
  },
  "common.text": {
    "defaultMessage": "Texte"
  },
  "common.text.actions": {
    "defaultMessage": "Actions"
  },
  "common.text.addFilter": {
    "defaultMessage": "Filtre"
  },
  "common.text.all": {
    "defaultMessage": "Tous"
  },
  "common.text.back": {
    "defaultMessage": "Retour"
  },
  "common.text.content": {
    "defaultMessage": "Contenu"
  },
  "common.text.count": {
    "defaultMessage": "Nombre"
  },
  "common.text.date": {
    "defaultMessage": "Date"
  },
  "common.text.description": {
    "defaultMessage": "Description"
  },
  "common.text.duration": {
    "defaultMessage": "durée"
  },
  "common.text.language": {
    "defaultMessage": "Langue"
  },
  "common.text.name": {
    "defaultMessage": "Nom"
  },
  "common.text.next": {
    "defaultMessage": "Suivant"
  },
  "common.text.no": {
    "defaultMessage": "Non"
  },
  "common.text.notSet": {
    "defaultMessage": "Non défini"
  },
  "common.text.subtitle": {
    "defaultMessage": "Sous-titre"
  },
  "common.text.time": {
    "defaultMessage": "Heure"
  },
  "common.text.timezone": {
    "defaultMessage": "Fuseau horaire"
  },
  "common.text.title": {
    "defaultMessage": "Titre"
  },
  "common.text.type": {
    "defaultMessage": "Type"
  },
  "common.text.yes": {
    "defaultMessage": "Oui"
  },
  "common.thumbnail": {
    "defaultMessage": "Miniature"
  },
  "common.thumbType": {
    "defaultMessage": "Type de miniature"
  },
  "common.timeEnd": {
    "defaultMessage": "Heure de fin"
  },
  "common.timeStart": {
    "defaultMessage": "Heure de début"
  },
  "common.title": {
    "defaultMessage": "Titre"
  },
  "common.truncate.hide": {
    "defaultMessage": "Masquer"
  },
  "common.truncate.showAll": {
    "defaultMessage": "Tout afficher"
  },
  "common.type": {
    "defaultMessage": "Type"
  },
  "common.updatedAt": {
    "defaultMessage": "Mis à jour le"
  },
  "common.users": {
    "defaultMessage": "Utilisateurs"
  },
  "common.video": {
    "defaultMessage": "vidéo"
  },
  "common.videoFrame": {
    "defaultMessage": "Image vidéo"
  },
  "common.visualize": {
    "defaultMessage": "Visualiser"
  },
  "common.wizard.back": {
    "defaultMessage": "Retour"
  },
  "common.wizard.finish": {
    "defaultMessage": "Terminer"
  },
  "common.wizard.next": {
    "defaultMessage": "Suivant"
  },
  "common.yes": {
    "defaultMessage": "Oui"
  },
  "compose.createComposition.action": {
    "defaultMessage": "Créer une composition"
  },
  "compose.createPage.fieldName": {
    "defaultMessage": "Nom"
  },
  "compose.createPage.successToast": {
    "defaultMessage": "Composition créée"
  },
  "compose.createPage.title": {
    "defaultMessage": "Créer une composition"
  },
  "compose.delete.message": {
    "defaultMessage": "Voulez-vous vraiment supprimer la composition « {name} » ? Cette action est irréversible."
  },
  "compose.delete.successToast": {
    "defaultMessage": "Composition supprimée"
  },
  "compose.delete.title": {
    "defaultMessage": "Supprimer la composition"
  },
  "compose.editPage.successToast": {
    "defaultMessage": "Composition mise à jour"
  },
  "compose.editPage.title": {
    "defaultMessage": "Modifier la composition"
  },
  "compose.filters.compositionName": {
    "defaultMessage": "Nom de la composition"
  },
  "compose.listCard.editsCount": {
    "defaultMessage": "{count, plural, one {# edit} other {# edits}}"
  },
  "compose.listCard.unpublished": {
    "defaultMessage": "Non publié"
  },
  "compose.listEmptyState.message": {
    "defaultMessage": "Aucune composition"
  },
  "compose.listScreen.hubLabel": {
    "defaultMessage": "Compose"
  },
  "compose.listScreen.title": {
    "defaultMessage": "Compose"
  },
  "compose.navTitle": {
    "defaultMessage": "Compose"
  },
  "compose.publish.tabTitle": {
    "defaultMessage": "Réseaux"
  },
  "compose.videoEditions.tabTitle": {
    "defaultMessage": "Montages"
  },
  "contentAi.articleNumber": {
    "defaultMessage": "ARTICLE {number}"
  },
  "contentAi.articles.generateContent": {
    "defaultMessage": "Générer du contenu"
  },
  "contentAi.articles.instructions": {
    "defaultMessage": "Instructions"
  },
  "contentAi.backToArticleSelection": {
    "defaultMessage": "Retour à la sélection d'articles"
  },
  "contentAi.configPerStation": {
    "defaultMessage": "Config par station"
  },
  "contentAi.configTitle": {
    "defaultMessage": "Config Content AI"
  },
  "contentAi.contentOrigin": {
    "defaultMessage": "Origine du contenu :"
  },
  "contentAi.contentsList.fragment": {
    "defaultMessage": "Fragment"
  },
  "contentAi.contentsList.source": {
    "defaultMessage": "Source"
  },
  "contentAi.contentsList.title": {
    "defaultMessage": "Content AI - Contenus"
  },
  "contentAi.contentsList.view": {
    "defaultMessage": "Voir"
  },
  "contentAi.copyToClipboard": {
    "defaultMessage": "Copier dans le presse-papiers"
  },
  "contentAi.externalExportEnabled": {
    "defaultMessage": "Export externe activé"
  },
  "contentAi.fragment": {
    "defaultMessage": "Fragment"
  },
  "contentAi.fragmentContentExists": {
    "defaultMessage": "Un contenu existe déjà pour ce fragment"
  },
  "contentAi.goToContent": {
    "defaultMessage": "Aller au contenu"
  },
  "contentAi.instructionsOptional": {
    "defaultMessage": "Instructions (optionnel)"
  },
  "contentAi.instructionsPlaceholder": {
    "defaultMessage": "Entrez les instructions ici."
  },
  "contentAi.placeholder.tone": {
    "defaultMessage": "Positif, négatif, neutre"
  },
  "contentAi.preparingMedia": {
    "defaultMessage": "Préparation des médias pour l'analyse"
  },
  "contentAi.regenerateArticles": {
    "defaultMessage": "Régénérer les articles"
  },
  "contentAi.saveAndContinue": {
    "defaultMessage": "Enregistrer et continuer"
  },
  "contentAi.socialVersion.generatedFor": {
    "defaultMessage": "Contenu généré pour {platform}"
  },
  "contentAi.socialVersion.generateFor": {
    "defaultMessage": "Générer du contenu pour {platform}"
  },
  "contentAi.socialVersion.publishContent": {
    "defaultMessage": "Publier le contenu"
  },
  "contentAi.socialVersion.publishError": {
    "defaultMessage": "Une erreur s'est produite lors de la publication de la version, veuillez réessayer"
  },
  "contentAi.socialVersion.regenerate": {
    "defaultMessage": "Régénérer"
  },
  "contentAi.stationConfig.addPrompt": {
    "defaultMessage": "Ajouter un nouveau prompt"
  },
  "contentAi.stationConfig.promptsTitle": {
    "defaultMessage": "Prompts"
  },
  "contentAi.stationConfig.updated": {
    "defaultMessage": "Config Content AI pour {stationName} mise à jour"
  },
  "contentAi.steps.adaptAndPublish": {
    "defaultMessage": "Adapter et publier sur les réseaux"
  },
  "contentAi.steps.aiArticles.choosePrompt": {
    "defaultMessage": "Choisir l'invite"
  },
  "contentAi.steps.editContent": {
    "defaultMessage": "Modifier le contenu"
  },
  "contentAi.steps.generateArticles": {
    "defaultMessage": "Générer les articles"
  },
  "contentAi.title": {
    "defaultMessage": "IA de contenu"
  },
  "contentAi.userArticle.generatedForWeb": {
    "defaultMessage": "Contenu généré pour le Web"
  },
  "contentAi.userArticle.primaryArticle": {
    "defaultMessage": "Article principal"
  },
  "contentAi.userArticle.useFooter": {
    "defaultMessage": "Utiliser le pied de page :"
  },
  "contentAi.useThisArticle": {
    "defaultMessage": "Utiliser cet article"
  },
  "contentAi.viewFullArticle": {
    "defaultMessage": "Voir l'article complet"
  },
  "contentAi.wizard.adaptContentTitle": {
    "defaultMessage": "Adaptez le contenu et publiez-le sur les réseaux."
  },
  "contentAi.wizard.almostThereTitle": {
    "defaultMessage": "Presque terminé ! Plus que {count} étapes."
  },
  "contentAi.wizard.createFragmentStep": {
    "defaultMessage": "Créer un fragment"
  },
  "contentAi.wizard.editArticleTitle": {
    "defaultMessage": "Modifiez votre article pour le publier."
  },
  "core.screen.hotkeys.modalTitle": {
    "defaultMessage": "Raccourcis clavier"
  },
  "core.screen.hotkeys.showBtnText": {
    "defaultMessage": "Raccourcis clavier"
  },
  "core.sidenav.adminIndicatorText": {
    "defaultMessage": "Admin"
  },
  "core.sidenav.collapseTooltip": {
    "defaultMessage": "Fermer le menu"
  },
  "core.sidenav.darkModeTooltip": {
    "defaultMessage": "Sombre"
  },
  "core.sidenav.defaultModeLabel": {
    "defaultMessage": "Default"
  },
  "core.sidenav.expandTooltip": {
    "defaultMessage": "Ouvrir le menu"
  },
  "core.sidenav.lightModeTooltip": {
    "defaultMessage": "Clair"
  },
  "core.sidenav.logoutBtnText": {
    "defaultMessage": "Déconnexion"
  },
  "core.sidenav.notificationsEmpty": {
    "defaultMessage": "Aucune notification"
  },
  "core.sidenav.settingsBtnText": {
    "defaultMessage": "Paramètres utilisateur"
  },
  "core.sidenav.themeToggle.tour.description": {
    "defaultMessage": "Ouvrez le menu du compte pour choisir Default, Sombre ou Clair."
  },
  "core.sidenav.themeToggle.tour.title": {
    "defaultMessage": "Options de thème disponibles"
  },
  "date.justNow": {
    "defaultMessage": "À l'instant"
  },
  "fleet.devices.card.lastSeen": {
    "defaultMessage": "Vu pour la dernière fois {relativeTime}"
  },
  "fleet.devices.card.mapAlt": {
    "defaultMessage": "Carte de {name}"
  },
  "fleet.devices.card.noLastSeen": {
    "defaultMessage": "Jamais vu en ligne"
  },
  "fleet.devices.card.openAdminPanel": {
    "defaultMessage": "Ouvrir le panneau d'administration"
  },
  "fleet.devices.card.viewOnMap": {
    "defaultMessage": "Voir sur la carte"
  },
  "fleet.devices.filters.id": {
    "defaultMessage": "ID"
  },
  "fleet.devices.filters.idPlaceholder": {
    "defaultMessage": "Rechercher par ID"
  },
  "fleet.devices.filters.name": {
    "defaultMessage": "Nom"
  },
  "fleet.devices.filters.namePlaceholder": {
    "defaultMessage": "Rechercher par nom"
  },
  "fleet.devices.filters.status": {
    "defaultMessage": "Statut"
  },
  "fleet.devices.listScreen.title": {
    "defaultMessage": "Devices"
  },
  "fleet.devices.status.offline": {
    "defaultMessage": "Offline"
  },
  "fleet.devices.status.online": {
    "defaultMessage": "Online"
  },
  "fleet.devices.type.airnode": {
    "defaultMessage": "AirNode"
  },
  "fleet.devices.type.streamBox": {
    "defaultMessage": "StreamBox"
  },
  "fleet.nav.title": {
    "defaultMessage": "Devices"
  },
  "form.array.addButtonLabel": {
    "defaultMessage": "Ajouter"
  },
  "form.array.emptyMessage": {
    "defaultMessage": "Aucun élément défini pour le moment"
  },
  "form.array.fieldError": {
    "defaultMessage": "Erreur dans le champ"
  },
  "form.frameThumbnailLabel": {
    "defaultMessage": "Image à utiliser comme miniature"
  },
  "fragmentMedia.audio.chunkPill.unlabeledChunk": {
    "defaultMessage": "Segment {n}"
  },
  "fragments.addScreen.createAndGoShort": {
    "defaultMessage": "Créer et aller"
  },
  "fragments.addScreen.createAndOpen": {
    "defaultMessage": "Créer et aller au fragment"
  },
  "fragments.addScreen.created": {
    "defaultMessage": "Fragment créé"
  },
  "fragments.addScreen.createError": {
    "defaultMessage": "Impossible de créer le fragment"
  },
  "fragments.addScreen.createOnly": {
    "defaultMessage": "Créer"
  },
  "fragments.addScreen.exportError": {
    "defaultMessage": "Impossible de démarrer l'export externe"
  },
  "fragments.addScreen.exportMissingConnection": {
    "defaultMessage": "Impossible de démarrer lexport : compte de publication manquant"
  },
  "fragments.addScreen.externalExportError": {
    "defaultMessage": "Impossible de démarrer l'export externe"
  },
  "fragments.addScreen.goTo": {
    "defaultMessage": "Aller au fragment"
  },
  "fragments.addScreen.splitSubmit.tour.description": {
    "defaultMessage": "Utilisez ce menu pour créer le fragment et aller au détail en une seule étape."
  },
  "fragments.addScreen.splitSubmit.tour.title": {
    "defaultMessage": "Créer et aller au fragment"
  },
  "fragments.card.posterProcessing": {
    "defaultMessage": "Traitement"
  },
  "fragments.cloneScreen.cloned": {
    "defaultMessage": "Fragment cloné"
  },
  "fragments.cloneScreen.cloneError": {
    "defaultMessage": "Impossible de cloner le fragment"
  },
  "fragments.cloneScreen.defaultTitle": {
    "defaultMessage": "{title} (copie)"
  },
  "fragments.cloneScreen.inputLabel": {
    "defaultMessage": "Nouveau titre"
  },
  "fragments.cloneScreen.inputRequired": {
    "defaultMessage": "Le titre est obligatoire"
  },
  "fragments.cloneScreen.title": {
    "defaultMessage": "Cloner le fragment"
  },
  "fragments.contentAi.generateFromFragment": {
    "defaultMessage": "Générer du contenu à partir de ce fragment"
  },
  "fragments.contentAi.noPermission": {
    "defaultMessage": "Vous n'avez pas la permission de créer du contenu"
  },
  "fragments.deleteScreen.deleted": {
    "defaultMessage": "Fragment supprimé"
  },
  "fragments.deleteScreen.deleteError": {
    "defaultMessage": "Impossible de supprimer le fragment"
  },
  "fragments.deleteScreen.prompt": {
    "defaultMessage": "Voulez-vous supprimer le fragment <b>{title}</b> ? {br} Cette action est irréversible."
  },
  "fragments.deleteScreen.title": {
    "defaultMessage": "Supprimer le fragment"
  },
  "fragments.delivery.destinationStation": {
    "defaultMessage": "Station de destination"
  },
  "fragments.delivery.exportStarted": {
    "defaultMessage": "Export démarré"
  },
  "fragments.delivery.exportStartError": {
    "defaultMessage": "Une erreur s'est produite lors du démarrage de l'export, veuillez contacter le support (statut : {status})"
  },
  "fragments.delivery.savedAt": {
    "defaultMessage": "Enregistré à {uri}"
  },
  "fragments.deliveryStatus.destinationStationLabel": {
    "defaultMessage": "Station de destination"
  },
  "fragments.deliveryStatus.enable": {
    "defaultMessage": "Activer l'export externe"
  },
  "fragments.deliveryStatus.none": {
    "defaultMessage": "Fragment non exporté"
  },
  "fragments.deliveryStatus.start": {
    "defaultMessage": "Démarrer l'export externe"
  },
  "fragments.export.audioMp3GeneratingTooltip": {
    "defaultMessage": "Génération du MP3 en cours"
  },
  "fragments.export.downloadAudioMp3": {
    "defaultMessage": "Télécharger l'audio (MP3)"
  },
  "fragments.export.downloadMedia": {
    "defaultMessage": "Télécharger {type}"
  },
  "fragments.export.downloadMediaAudioAac": {
    "defaultMessage": "Télécharger {type} (aac)"
  },
  "fragments.export.publishError": {
    "defaultMessage": "Une erreur s'est produite lors de la publication"
  },
  "fragments.export.publishingInProgress": {
    "defaultMessage": "Publication en cours..."
  },
  "fragments.exportStatus.externalExportNotEnabled": {
    "defaultMessage": "L'export externe n'est pas activé, veuillez contacter le support."
  },
  "fragments.exportStatus.ready": {
    "defaultMessage": "Prêt"
  },
  "fragments.exportView.tabExternalExport": {
    "defaultMessage": "Export"
  },
  "fragments.exportView.tabFiles": {
    "defaultMessage": "Fichiers"
  },
  "fragments.exportView.tabPublish": {
    "defaultMessage": "Réseaux"
  },
  "fragments.filter.hasContentAi": {
    "defaultMessage": "Contenido AI"
  },
  "fragments.filter.hasExternalDelivery": {
    "defaultMessage": "Export externe"
  },
  "fragments.filter.onlyMine": {
    "defaultMessage": "Seulement les miens"
  },
  "fragments.filter.publishedPlatforms": {
    "defaultMessage": "Plataformas publicadas"
  },
  "fragments.form.addEmoji": {
    "defaultMessage": "Add emoji"
  },
  "fragments.form.description.placeholder": {
    "defaultMessage": "Ex. : Enregistré au stade Loujniki à Moscou pendant la Coupe du monde"
  },
  "fragments.form.emojiPickerOk": {
    "defaultMessage": "OK"
  },
  "fragments.form.emojiSearchPlaceholder": {
    "defaultMessage": "Rechercher"
  },
  "fragments.form.footer.placeholder": {
    "defaultMessage": "Add footer"
  },
  "fragments.form.header": {
    "defaultMessage": "Créer un fragment"
  },
  "fragments.form.header.noRangeSelected": {
    "defaultMessage": "Aucune plage sélectionnée"
  },
  "fragments.form.publishOn": {
    "defaultMessage": "Publication rapide"
  },
  "fragments.form.tags.placeholder": {
    "defaultMessage": "Ex. : interview, messi, coupe du monde, moscou"
  },
  "fragments.form.title.placeholder": {
    "defaultMessage": "Ex. : Interview avec Messi"
  },
  "fragments.listScreen.allFragments": {
    "defaultMessage": "Fragments"
  },
  "fragments.listScreen.failed": {
    "defaultMessage": "Échec de l'envoi vers"
  },
  "fragments.listScreen.scheduled": {
    "defaultMessage": "Programmé"
  },
  "fragments.listScreen.sentTo": {
    "defaultMessage": "Envoyé à"
  },
  "fragments.listScreen.unpublished": {
    "defaultMessage": "Non publié"
  },
  "fragments.listV3.section.previous": {
    "defaultMessage": "Précédents"
  },
  "fragments.listV3.section.today": {
    "defaultMessage": "Aujourd'hui"
  },
  "fragments.listV3.section.yesterday": {
    "defaultMessage": "Hier"
  },
  "fragments.listV3.tour.addFilter.description": {
    "defaultMessage": "Ajoutez des filtres comme Contenu IA, Export externe et Plateformes publiées depuis ce bouton pour affiner la liste des fragments."
  },
  "fragments.listV3.tour.addFilter.title": {
    "defaultMessage": "Nouveaux filtres disponibles"
  },
  "fragments.listV3.tour.viewToggle.description": {
    "defaultMessage": "Passez de la liste à la grille (large, normale ou compacte) pour afficher les fragments comme vous le souhaitez."
  },
  "fragments.listV3.tour.viewToggle.title": {
    "defaultMessage": "Vue des fragments"
  },
  "fragments.mediaStatus.regenerate": {
    "defaultMessage": "Pas de progrès ? Régénérer le média"
  },
  "fragments.mediaStatus.regenerateError": {
    "defaultMessage": "Impossible de régénérer le média"
  },
  "fragments.mediaStatus.regenerateStarted": {
    "defaultMessage": "Régénération du média du fragment démarrée"
  },
  "fragments.mediaStatus.title": {
    "defaultMessage": "Fichier média"
  },
  "fragments.mediaStatus.waiting": {
    "defaultMessage": "Génération du média en cours"
  },
  "fragments.props.createdBy": {
    "defaultMessage": "Créé par"
  },
  "fragments.props.description": {
    "defaultMessage": "Description"
  },
  "fragments.props.tag": {
    "defaultMessage": "Tag"
  },
  "fragments.props.tags": {
    "defaultMessage": "Tags"
  },
  "fragments.props.title": {
    "defaultMessage": "Title"
  },
  "fragments.subtitlesStatus.add": {
    "defaultMessage": "Add speaker ID"
  },
  "fragments.subtitlesStatus.download": {
    "defaultMessage": "Download subtitles"
  },
  "fragments.subtitlesStatus.formatJson": {
    "defaultMessage": ".JSON"
  },
  "fragments.subtitlesStatus.formatSrt": {
    "defaultMessage": ".SRT"
  },
  "fragments.subtitlesStatus.formatTxt": {
    "defaultMessage": ".TXT"
  },
  "fragments.subtitlesStatus.title": {
    "defaultMessage": "Sous-titres"
  },
  "fragments.title": {
    "defaultMessage": "Fragments"
  },
  "fragments.transcription.panelTitle": {
    "defaultMessage": "Transcription"
  },
  "fragments.transcription.v2.editModeTooltipOff": {
    "defaultMessage": "Mode édition : désactivé"
  },
  "fragments.transcription.v2.editModeTooltipOn": {
    "defaultMessage": "Mode édition : activé"
  },
  "fragments.transcription.v2.editSaveError": {
    "defaultMessage": "Impossible d'enregistrer le mot. Veuillez réessayer."
  },
  "fragments.transcription.v2.efficiencyTooltipOff": {
    "defaultMessage": "Efficacité par mot : désactivée"
  },
  "fragments.transcription.v2.efficiencyTooltipOn": {
    "defaultMessage": "Efficacité par mot : activée"
  },
  "fragments.transcription.v2.searchNoMatches": {
    "defaultMessage": "Aucune correspondance"
  },
  "fragments.transcription.v2.searchTooltipOff": {
    "defaultMessage": "Recherche : désactivée"
  },
  "fragments.transcription.v2.searchTooltipOn": {
    "defaultMessage": "Recherche : activée"
  },
  "fragments.transcription.v2.syncTooltipOff": {
    "defaultMessage": "Synchroniser la transcription avec la lecture : désactivé"
  },
  "fragments.transcription.v2.syncTooltipOn": {
    "defaultMessage": "Synchroniser la transcription avec la lecture : activé"
  },
  "fragments.video.subtitlesTrackLabel": {
    "defaultMessage": "Sous-titres"
  },
  "fragments.view.descriptionTitle": {
    "defaultMessage": "Description"
  },
  "fragments.view.metadata.openInLogger": {
    "defaultMessage": "Ouvrir dans le Logger :"
  },
  "fragments.view.metadata.goToStream": {
    "defaultMessage": "Début"
  },
  "fragments.view.metadata.goToStreamFromPlayback": {
    "defaultMessage": "Temps actuel"
  },
  "fragments.view.metadata.goToStreamWithSelection": {
    "defaultMessage": "Sélection"
  },
  "fragments.view.regenerateMedia": {
    "defaultMessage": "Régénérer le média"
  },
  "fragments.viewScreen.mediaNotReadyTooltip": {
    "defaultMessage": "En attente du média du fragment"
  },
  "fragments.viewScreen.title": {
    "defaultMessage": "Infos"
  },
  "fragments.viewScreen.transcriptionNotReadyTooltip": {
    "defaultMessage": "En attente de la transcription du fragment"
  },
  "globalLivePlayer.title": {
    "defaultMessage": "Lecteur en direct"
  },
  "impersonation.currentUserTitle": {
    "defaultMessage": "Utilisateur actuel"
  },
  "impersonation.deleteAriaLabel": {
    "defaultMessage": "Supprimer"
  },
  "impersonation.recentUsersTitle": {
    "defaultMessage": "Utilisateurs récemment impersonnés"
  },
  "itemsViewLayout.gridCompact": {
    "defaultMessage": "Grille compacte"
  },
  "itemsViewLayout.gridNormal": {
    "defaultMessage": "Grille normale"
  },
  "itemsViewLayout.gridWide": {
    "defaultMessage": "Grille large"
  },
  "itemsViewLayout.list": {
    "defaultMessage": "Liste"
  },
  "jointFragments.chunkLabel.edit": {
    "defaultMessage": "Modifier l'étiquette"
  },
  "jointFragments.chunkLabel.field": {
    "defaultMessage": "New label"
  },
  "jointFragments.chunkLabel.modalTitle": {
    "defaultMessage": "Set segment label"
  },
  "jointFragments.editorScreen.chunkActions.delete": {
    "defaultMessage": "Delete this segment"
  },
  "jointFragments.editorScreen.chunkActions.moveAfter": {
    "defaultMessage": "Déplacer après"
  },
  "jointFragments.editorScreen.chunkActions.moveBefore": {
    "defaultMessage": "Déplacer avant"
  },
  "jointFragments.editorScreen.noChunks": {
    "defaultMessage": "No segments added yet to the fragment"
  },
  "jointFragments.editorScreen.title": {
    "defaultMessage": "Éditeur"
  },
  "jointFragments.editorScreen.toolbar.create": {
    "defaultMessage": "Créer un fragment"
  },
  "jointFragments.form.externalExport.allowedLabel": {
    "defaultMessage": "Export externe"
  },
  "jointFragments.overview.closeEditor": {
    "defaultMessage": "Close editor"
  },
  "jointFragments.overview.createNew": {
    "defaultMessage": "Create new fragment"
  },
  "jointFragments.overview.detailLink": {
    "defaultMessage": "View fragment detail"
  },
  "jointFragments.overview.message": {
    "defaultMessage": "Fragment was saved"
  },
  "jointFragments.props.chunk": {
    "defaultMessage": "Segment"
  },
  "livePlayer.toggle.mode.fullscreen": {
    "defaultMessage": "Ouvrir en plein écran"
  },
  "livePlayer.toggle.mode.inline": {
    "defaultMessage": "Ouvrir en miniature"
  },
  "livePlayer.toggle.tooltip": {
    "defaultMessage": "Ouvrir LIVE"
  },
  "logger.auditControls.audioMatches": {
    "defaultMessage": "Correspondances audio"
  },
  "logger.auditControls.mentionMatches": {
    "defaultMessage": "Correspondances de mentions"
  },
  "logger.diarization.confidence": {
    "defaultMessage": "Confiance"
  },
  "logger.downloadingSegments": {
    "defaultMessage": "Downloading segments {progress}%"
  },
  "logger.liveMentions.showMention": {
    "defaultMessage": "Show mention"
  },
  "logger.navLabel": {
    "defaultMessage": "Logger"
  },
  "logger.persons.empty": {
    "defaultMessage": "Aucune personne détectée dans cette plage"
  },
  "logger.persons.filter.all": {
    "defaultMessage": "Toutes"
  },
  "logger.persons.filter.face": {
    "defaultMessage": "Avec visage"
  },
  "logger.persons.filter.unknown": {
    "defaultMessage": "Non identifiées"
  },
  "logger.persons.filter.voice": {
    "defaultMessage": "Avec voix"
  },
  "logger.persons.source.face": {
    "defaultMessage": "Visage"
  },
  "logger.persons.source.voice": {
    "defaultMessage": "Voix"
  },
  "logger.persons.table.appearances": {
    "defaultMessage": "Apparitions"
  },
  "logger.persons.table.appearancesDetail": {
    "defaultMessage": "Détail des apparitions"
  },
  "logger.persons.table.confidence": {
    "defaultMessage": "Confiance"
  },
  "logger.persons.table.onScreen": {
    "defaultMessage": "À l'écran"
  },
  "logger.persons.table.sources": {
    "defaultMessage": "Sources"
  },
  "logger.persons.table.speaking": {
    "defaultMessage": "Parle"
  },
  "logger.persons.table.timeline": {
    "defaultMessage": "Apparitions dans le focus"
  },
  "logger.persons.track.collapse": {
    "defaultMessage": "Réduire"
  },
  "logger.persons.track.lanes": {
    "defaultMessage": "Voir par personne"
  },
  "logger.persons.track.title": {
    "defaultMessage": "Personnes"
  },
  "logger.persons.unknown": {
    "defaultMessage": "Personne non identifiée"
  },
  "logger.reports.loggerReportsTitle": {
    "defaultMessage": "Rapports Logger"
  },
  "logger.reports.streamQuality.availability.rangeBrush.label": {
    "defaultMessage": "Ajuster la plage"
  },
  "logger.reports.streamQuality.availability.rangeBrush.resetFullRange": {
    "defaultMessage": "Afficher toute la période du rapport"
  },
  "logger.reports.streamQuality.availability.table.action.openLogger": {
    "defaultMessage": "Ouvrir le logger à ce moment"
  },
  "logger.reports.streamQuality.availability.table.col.duration": {
    "defaultMessage": "Durée"
  },
  "logger.reports.streamQuality.availability.table.col.end": {
    "defaultMessage": "Fin"
  },
  "logger.reports.streamQuality.availability.table.col.issueType": {
    "defaultMessage": "Type"
  },
  "logger.reports.streamQuality.availability.table.col.start": {
    "defaultMessage": "Début"
  },
  "logger.reports.streamQuality.availability.table.col.station": {
    "defaultMessage": "Station"
  },
  "logger.reports.streamQuality.availability.tooltip.clickOpenLogger": {
    "defaultMessage": "Cliquer pour afficher dans le Logger"
  },
  "logger.reports.streamQuality.availability.tooltip.duration": {
    "defaultMessage": "Durée : {duration}"
  },
  "logger.reports.streamQuality.availability.tooltip.gap": {
    "defaultMessage": "Aucune diffusion"
  },
  "logger.reports.streamQuality.availability.tooltip.issueKind.poorQuality": {
    "defaultMessage": "Qualité médiocre"
  },
  "logger.reports.streamQuality.availability.tooltip.issueKind.silent": {
    "defaultMessage": "Silence"
  },
  "logger.reports.streamQuality.availability.tooltip.range": {
    "defaultMessage": "{from} – {to}"
  },
  "logger.reports.streamQuality.emptyState.help": {
    "defaultMessage": "Choisissez la plage de dates et les stations pour générer le rapport."
  },
  "logger.reports.streamQuality.form.dateRangeLabel": {
    "defaultMessage": "Plage de dates"
  },
  "logger.reports.streamQuality.form.stationsLabel": {
    "defaultMessage": "Stations"
  },
  "logger.reports.streamQuality.form.stationsPlaceholder": {
    "defaultMessage": "Toutes les stations"
  },
  "logger.reports.streamQuality.kpis.continuityIncidentDurationAvg": {
    "defaultMessage": "Durée moyenne des incidents de continuité"
  },
  "logger.reports.streamQuality.kpis.continuityIncidentsTotal": {
    "defaultMessage": "Incidents de continuité"
  },
  "logger.reports.streamQuality.kpis.healthScore": {
    "defaultMessage": "Score de santé"
  },
  "logger.reports.streamQuality.kpis.qualityAvgNotApplicable": {
    "defaultMessage": "—"
  },
  "logger.reports.streamQuality.kpis.qualityIncidentDurationAvg": {
    "defaultMessage": "Durée moyenne des incidents de qualité"
  },
  "logger.reports.streamQuality.kpis.qualityIncidentsTotal": {
    "defaultMessage": "Incidents de qualité"
  },
  "logger.reports.streamQuality.kpis.stationsWithContinuityIncidents": {
    "defaultMessage": "Stations avec incidents de continuité"
  },
  "logger.reports.streamQuality.kpis.stationsWithIncidents": {
    "defaultMessage": "Stations avec incidents"
  },
  "logger.reports.streamQuality.kpis.stationsWithQualityIncidents": {
    "defaultMessage": "Stations avec incidents de qualité"
  },
  "logger.reports.streamQuality.stationStatusFilter.disabledAnalysisIntervalsLegend": {
    "defaultMessage": "= Intervalle sans contrôle qualité"
  },
  "logger.reports.streamQuality.stationStatusFilter.discontinuity": {
    "defaultMessage": "Discontinuité"
  },
  "logger.reports.streamQuality.stationStatusFilter.filterByIncidentsLabel": {
    "defaultMessage": "Filtrer par incidents : "
  },
  "logger.reports.streamQuality.stationStatusFilter.noIncidents": {
    "defaultMessage": "Sans incident"
  },
  "logger.reports.streamQuality.stationStatusFilter.noMatchingStations": {
    "defaultMessage": "Aucune station ne correspond aux filtres sélectionnés. Essayez une autre combinaison."
  },
  "logger.reports.streamQuality.stationStatusFilter.poorQuality": {
    "defaultMessage": "Qualité médiocre"
  },
  "logger.reports.streamQuality.stationStatusFilter.silent": {
    "defaultMessage": "Silence"
  },
  "logger.reports.streamQuality.tabLabel": {
    "defaultMessage": "Qualité du flux"
  },
  "logger.sidenav.panorama": {
    "defaultMessage": "Panorama"
  },
  "logger.sidenav.reportes": {
    "defaultMessage": "Rapports"
  },
  "logger.sidenav.youtube": {
    "defaultMessage": "YouTube"
  },
  "logger.status.filter.offline": {
    "defaultMessage": "Hors ligne"
  },
  "logger.status.filter.online": {
    "defaultMessage": "En ligne"
  },
  "logger.statusScreen.cleanFilters": {
    "defaultMessage": "Effacer les filtres"
  },
  "logger.statusScreen.count": {
    "defaultMessage": "{count, plural, =0 {No stations found} one {1 station found} other {# stations found} }"
  },
  "logger.statusScreen.enterFullscreen": {
    "defaultMessage": "Plein écran"
  },
  "logger.statusScreen.exitFullscreen": {
    "defaultMessage": "Quitter le plein écran"
  },
  "logger.statusScreen.favoritesSection": {
    "defaultMessage": "Favoris ({count})"
  },
  "logger.statusScreen.groupSection": {
    "defaultMessage": "{name} ({count})"
  },
  "logger.statusScreen.loading": {
    "defaultMessage": "Loading logger status"
  },
  "logger.statusScreen.myStationsSection": {
    "defaultMessage": "Mes stations ({count})"
  },
  "logger.statusScreen.noActivity": {
    "defaultMessage": "No recent activity registered"
  },
  "logger.statusScreen.sharedStationsSection": {
    "defaultMessage": "Stations externes ({count})"
  },
  "logger.statusScreen.stationAccess": {
    "defaultMessage": "Accès aux stations"
  },
  "logger.statusScreen.stationAccessOwned": {
    "defaultMessage": "Mes stations"
  },
  "logger.statusScreen.stationAccessShared": {
    "defaultMessage": "Stations externes"
  },
  "logger.statusScreen.stationType": {
    "defaultMessage": "Type de station"
  },
  "logger.statusScreen.stationTypeRadio": {
    "defaultMessage": "Radio"
  },
  "logger.statusScreen.stationTypeTv": {
    "defaultMessage": "TV"
  },
  "logger.statusScreen.stationTypeYoutube": {
    "defaultMessage": "YouTube"
  },
  "logger.statusScreen.statusActivity": {
    "defaultMessage": "État"
  },
  "logger.statusScreen.title": {
    "defaultMessage": "Panorama"
  },
  "logger.statusScreen.tour.viewToggle.description": {
    "defaultMessage": "Passez de la liste à la grille (large, normale ou compacte) pour afficher les stations comme vous le souhaitez."
  },
  "logger.statusScreen.tour.viewToggle.title": {
    "defaultMessage": "Vue des stations"
  },
  "logger.statusScreen.youtubeNative.last24h": {
    "defaultMessage": "Dernières 24 heures"
  },
  "logger.statusScreen.youtubeNative.noEmissionInProgress": {
    "defaultMessage": "Aucune émission en cours"
  },
  "logger.statusScreen.youtubeNative.noRecentBroadcastsHelp": {
    "defaultMessage": "Aucune transmission enregistrée au cours des dernières 24 heures."
  },
  "logger.statusScreen.youtubeNative.offline": {
    "defaultMessage": "OFFLINE"
  },
  "logger.statusScreen.youtubeNative.peakViewersTooltip": {
    "defaultMessage": "{count} spectateurs au pic"
  },
  "logger.statusScreen.youtubeNative.recentTransmissions": {
    "defaultMessage": "Transmissions récentes"
  },
  "logger.statusScreen.youtubeNative.today": {
    "defaultMessage": "Aujourd'hui"
  },
  "logger.statusScreen.youtubeNative.yesterday": {
    "defaultMessage": "Hier"
  },
  "logger.streamBox.goToDevice": {
    "defaultMessage": "Aller à l'appareil"
  },
  "logger.streamScreen.audit.adOverlayLabel": {
    "defaultMessage": "Ad Overlay"
  },
  "logger.streamScreen.auditControls.adOverlay": {
    "defaultMessage": "Overlay publicitaire"
  },
  "logger.streamScreen.auditControls.youTubeViewers": {
    "defaultMessage": "Spectateurs YouTube"
  },
  "logger.streamScreen.autoOpenFragment.never": {
    "defaultMessage": "Jamais"
  },
  "logger.streamScreen.autoOpenFragment.onStartAndEnd": {
    "defaultMessage": "Lors du marquage début et fin"
  },
  "logger.streamScreen.autoOpenFragment.onStartOrEnd": {
    "defaultMessage": "Lors du marquage début ou fin"
  },
  "logger.streamScreen.controls.liveIndicator": {
    "defaultMessage": "Live"
  },
  "logger.streamScreen.controls.loadLatestBtn": {
    "defaultMessage": "Aller à l'émission actuelle"
  },
  "logger.streamScreen.controls.partialSegmentCoverage.tooltip": {
    "defaultMessage": "Aucune émission n'est disponible pour toute la plage sélectionnée. Seule la partie de la plage avec émission est affichée. (Plage disponible : {fromTime} - {toTime})"
  },
  "logger.streamScreen.controls.playLive": {
    "defaultMessage": "Play live stream"
  },
  "logger.streamScreen.controls.stop": {
    "defaultMessage": "Stop"
  },
  "logger.streamScreen.controls.timeMove.back15m": {
    "defaultMessage": "-15m"
  },
  "logger.streamScreen.controls.timeMove.back1h": {
    "defaultMessage": "-1h"
  },
  "logger.streamScreen.controls.timeMove.forward15m": {
    "defaultMessage": "+15m"
  },
  "logger.streamScreen.controls.timeMove.forward1h": {
    "defaultMessage": "+1h"
  },
  "logger.streamScreen.controls.updated": {
    "defaultMessage": "Mis à jour <time>{time}</time>"
  },
  "logger.streamScreen.controls.youtubeBroadcastsList": {
    "defaultMessage": "Voir toutes les diffusions"
  },
  "logger.streamScreen.controls.youtubeLiveViewers": {
    "defaultMessage": "{count} spectateurs en direct"
  },
  "logger.streamScreen.copyCursorAt": {
    "defaultMessage": "Copier le lien avec l'horodatage {value}"
  },
  "logger.streamScreen.copyCursorLinkCopied": {
    "defaultMessage": "Lien copié dans le presse-papiers"
  },
  "logger.streamScreen.cursorMenu.cancel": {
    "defaultMessage": "Cancel"
  },
  "logger.streamScreen.cursorMenu.endSelection": {
    "defaultMessage": "End selection here"
  },
  "logger.streamScreen.cursorMenu.startSelection": {
    "defaultMessage": "Start selection here"
  },
  "logger.streamScreen.downloadMedia.downloadError": {
    "defaultMessage": "Impossible d'obtenir le lien de téléchargement"
  },
  "logger.streamScreen.downloadMedia.enqueueError": {
    "defaultMessage": "Impossible de démarrer l'export. Veuillez réessayer."
  },
  "logger.streamScreen.downloadMedia.error": {
    "defaultMessage": "Erreur lors du chargement du statut d'export"
  },
  "logger.streamScreen.downloadMedia.fileGeneratedSuccessfully": {
    "defaultMessage": "Fichier généré correctement"
  },
  "logger.streamScreen.downloadMedia.preparing": {
    "defaultMessage": "Préparation du fichier..."
  },
  "logger.streamScreen.focusTracks.hide": {
    "defaultMessage": "Masquer la piste"
  },
  "logger.streamScreen.focusTracks.show": {
    "defaultMessage": "Afficher la piste"
  },
  "logger.streamScreen.hotkeys.ADD_CHUNK_FROM_FOCUS_SELECTION.label": {
    "defaultMessage": "Ajouter la sélection au fragment joint"
  },
  "logger.streamScreen.hotkeys.category.cursor": {
    "defaultMessage": "Curseur"
  },
  "logger.streamScreen.hotkeys.category.focus": {
    "defaultMessage": "Focus"
  },
  "logger.streamScreen.hotkeys.category.playback": {
    "defaultMessage": "Lecture"
  },
  "logger.streamScreen.hotkeys.category.selection": {
    "defaultMessage": "Sélection"
  },
  "logger.streamScreen.hotkeys.CLEAR_SELECTION.label": {
    "defaultMessage": "Effacer la sélection"
  },
  "logger.streamScreen.hotkeys.CREATE_FRAGMENT.label": {
    "defaultMessage": "Créer un fragment à partir de la sélection"
  },
  "logger.streamScreen.hotkeys.CURSOR_BACK_1S.label": {
    "defaultMessage": "Déplacer le curseur d'une seconde en arrière"
  },
  "logger.streamScreen.hotkeys.CURSOR_BACK_5S.label": {
    "defaultMessage": "Déplacer le curseur de 5 secondes en arrière"
  },
  "logger.streamScreen.hotkeys.CURSOR_FORWARD_1S.label": {
    "defaultMessage": "Déplacer le curseur d'une seconde en avant"
  },
  "logger.streamScreen.hotkeys.CURSOR_FORWARD_5S.label": {
    "defaultMessage": "Déplacer le curseur de 5 secondes en avant"
  },
  "logger.streamScreen.hotkeys.DECREMENT_CURSOR_SELECTION.label": {
    "defaultMessage": "Réduire la plage de sélection de 5 secondes"
  },
  "logger.streamScreen.hotkeys.DOWNLOAD_AUDIO_SELECTION_VIDEO_ONLY.label": {
    "defaultMessage": "Télécharger l'audio de la sélection (uniquement pour les stations vidéo)"
  },
  "logger.streamScreen.hotkeys.DOWNLOAD_SELECTION.label": {
    "defaultMessage": "Télécharger la sélection"
  },
  "logger.streamScreen.hotkeys.END_CURSOR_SELECTION.label": {
    "defaultMessage": "Terminer la sélection depuis le curseur"
  },
  "logger.streamScreen.hotkeys.END_PLAY_TS_SELECTION.label": {
    "defaultMessage": "Terminer la sélection depuis le temps de lecture actuel"
  },
  "logger.streamScreen.hotkeys.FOCUS_BACK_5M.label": {
    "defaultMessage": "Déplacer le focus de 5 minutes en arrière"
  },
  "logger.streamScreen.hotkeys.FOCUS_FORWARD_5M.label": {
    "defaultMessage": "Déplacer le focus de 5 minutes en avant"
  },
  "logger.streamScreen.hotkeys.FOCUS_FULL_IN.label": {
    "defaultMessage": "Zoom complet sur le curseur ou la sélection"
  },
  "logger.streamScreen.hotkeys.FOCUS_FULL_OUT.label": {
    "defaultMessage": "Zoom complet vers l'extérieur"
  },
  "logger.streamScreen.hotkeys.FOCUS_ZOOM_SELECTION_IN.label": {
    "defaultMessage": "Zoom sur le début de la sélection"
  },
  "logger.streamScreen.hotkeys.FOCUS_ZOOM_SELECTION_OUT.label": {
    "defaultMessage": "Zoom sur la fin de la sélection"
  },
  "logger.streamScreen.hotkeys.INCREMENT_CURSOR_SELECTION.label": {
    "defaultMessage": "Augmenter la plage de sélection de 5 secondes"
  },
  "logger.streamScreen.hotkeys.PLAY_PAUSE.label": {
    "defaultMessage": "Lecture / pause"
  },
  "logger.streamScreen.hotkeys.START_CURSOR_SELECTION.label": {
    "defaultMessage": "Démarrer la sélection depuis le curseur"
  },
  "logger.streamScreen.hotkeys.START_PLAY_TS_SELECTION.label": {
    "defaultMessage": "Démarrer la sélection depuis le temps de lecture actuel"
  },
  "logger.streamScreen.hotkeys.STREAM_BACK_1H.label": {
    "defaultMessage": "Déplacer le focus d'une heure en arrière"
  },
  "logger.streamScreen.hotkeys.STREAM_FORWARD_1H.label": {
    "defaultMessage": "Déplacer le focus d'une heure en avant"
  },
  "logger.streamScreen.hotkeys.ZOOM_IN_FOCUS.label": {
    "defaultMessage": "Zoom avant sur le focus"
  },
  "logger.streamScreen.hotkeys.ZOOM_OUT_FOCUS.label": {
    "defaultMessage": "Zoom arrière sur le focus"
  },
  "logger.streamScreen.liveTopic.comesFrom": {
    "defaultMessage": "Provient de : "
  },
  "logger.streamScreen.liveTopics.entities.orgs": {
    "defaultMessage": "Organisations"
  },
  "logger.streamScreen.liveTopics.entities.people": {
    "defaultMessage": "Personnes"
  },
  "logger.streamScreen.liveTopics.entities.places": {
    "defaultMessage": "Lieux"
  },
  "logger.streamScreen.liveTopics.noTopicsForRange": {
    "defaultMessage": "Aucun sujet détecté pour cette plage"
  },
  "logger.streamScreen.liveTopics.panel.categoryFilterLabel": {
    "defaultMessage": "Catégorie"
  },
  "logger.streamScreen.liveTopics.panel.categoryFilterPlaceholder": {
    "defaultMessage": "Toutes les catégories"
  },
  "logger.streamScreen.liveTopics.panel.goTo": {
    "defaultMessage": "Aller"
  },
  "logger.streamScreen.liveTopics.panel.itemDeveloping": {
    "defaultMessage": "En cours"
  },
  "logger.streamScreen.liveTopics.panel.itemNew": {
    "defaultMessage": "Nouveau"
  },
  "logger.streamScreen.liveTopics.panel.keyPoints": {
    "defaultMessage": "Points clés"
  },
  "logger.streamScreen.liveTopics.panel.loadMoreOtherDay": {
    "defaultMessage": "Afficher les précédents avant le {date} {time}"
  },
  "logger.streamScreen.liveTopics.panel.loadMoreToday": {
    "defaultMessage": "Afficher les précédents avant {time}"
  },
  "logger.streamScreen.liveTopics.panel.newTopics": {
    "defaultMessage": "{count, plural, one {# nouveau sujet} other {# nouveaux sujets}}"
  },
  "logger.streamScreen.liveTopics.panel.openPanel": {
    "defaultMessage": "Live Topics"
  },
  "logger.streamScreen.liveTopics.panel.textFilterClearButton": {
    "defaultMessage": "Effacer la recherche"
  },
  "logger.streamScreen.liveTopics.panel.textFilterLabel": {
    "defaultMessage": "Texte"
  },
  "logger.streamScreen.liveTopics.panel.title": {
    "defaultMessage": "Live Topics"
  },
  "logger.streamScreen.liveTopics.popup.openInPanel": {
    "defaultMessage": "Voir plus de détails"
  },
  "logger.streamScreen.liveTopics.track.title": {
    "defaultMessage": "Live Topics"
  },
  "logger.streamScreen.modes.defaultMode": {
    "defaultMessage": "Default mode"
  },
  "logger.streamScreen.modes.editorMode": {
    "defaultMessage": "Editor mode"
  },
  "logger.streamScreen.screenSettings.autoOpenFragment": {
    "defaultMessage": "Ouvrir la création de fragment lors de la sélection (mode par défaut)"
  },
  "logger.streamScreen.screenSettings.btn": {
    "defaultMessage": "Settings"
  },
  "logger.streamScreen.screenSettings.keepSelectionOnRangeChange": {
    "defaultMessage": "Conserver la sélection lors du changement de plage"
  },
  "logger.streamScreen.screenSettings.playOnCursorSet": {
    "defaultMessage": "Lire lors du marquage"
  },
  "logger.streamScreen.screenSettings.screenMode": {
    "defaultMessage": "Screen mode"
  },
  "logger.streamScreen.screenSettings.tooltip": {
    "defaultMessage": "Paramètres d'écran"
  },
  "logger.streamScreen.selection.clear": {
    "defaultMessage": "Effacer la sélection"
  },
  "logger.streamScreen.selectionMenu.copyQuickShare": {
    "defaultMessage": "Copier le lien de partage rapide"
  },
  "logger.streamScreen.selectionMenu.copyQuickShareDone": {
    "defaultMessage": "URL Quick Share copiée"
  },
  "logger.streamScreen.selectionMenu.createFragment": {
    "defaultMessage": "Create fragment"
  },
  "logger.streamScreen.selectionMenu.unselect": {
    "defaultMessage": "Unselect"
  },
  "logger.youtubeBroadcasts.noYoutubeNativeStations": {
    "defaultMessage": "Aucune station avec intégration YouTube Native"
  },
  "logger.youtubeBroadcasts.pageTitle": {
    "defaultMessage": "Diffusions YouTube"
  },
  "logger.youtubePanorama.noRecentBroadcasts": {
    "defaultMessage": "Aucune diffusion récente"
  },
  "logger.youtubePanorama.recentTransmissionsTitle": {
    "defaultMessage": "Dernières diffusions"
  },
  "logger.youtubePanorama.recentTransmissionTitle": {
    "defaultMessage": "Dernière diffusion"
  },
  "logger.youtubePanorama.viewAll": {
    "defaultMessage": "Voir toutes les diffusions"
  },
  "logger.youtubeStats.legend.channels": {
    "defaultMessage": "Chaînes"
  },
  "logger.youtubeStats.legend.otherChannels": {
    "defaultMessage": "Autres chaînes"
  },
  "logger.youtubeStats.legend.ownChannel": {
    "defaultMessage": "Chaîne propre"
  },
  "logger.youtubeStats.legend.selectAll": {
    "defaultMessage": "Tout sélectionner"
  },
  "logger.youtubeStats.legend.selectNone": {
    "defaultMessage": "Tout désélectionner"
  },
  "logger.youtubeStats.noDataForPeriod": {
    "defaultMessage": "Aucune donnée disponible pour cette période"
  },
  "logger.youtubeStats.openYoutubeAtThisMoment": {
    "defaultMessage": "Cliquez pour aller sur YouTube à ce moment"
  },
  "modulesAdminLocaleEs.m.admin.groups.addScreen.title": {
    "defaultMessage": "Create new group"
  },
  "modulesAdminLocaleEs.m.admin.groups.editScreen.title": {
    "defaultMessage": "Edit group"
  },
  "notifications.feed.archive": {
    "defaultMessage": "Archiver"
  },
  "notifications.feed.filterAll": {
    "defaultMessage": "Toutes"
  },
  "notifications.feed.filterRead": {
    "defaultMessage": "Lues"
  },
  "notifications.feed.filterUnread": {
    "defaultMessage": "Non lues"
  },
  "notifications.feed.loadMore": {
    "defaultMessage": "Charger plus"
  },
  "notifications.feed.markAllRead": {
    "defaultMessage": "Tout marquer comme lu"
  },
  "notifications.feed.title": {
    "defaultMessage": "Notifications"
  },
  "notifications.item.fallbackTitle": {
    "defaultMessage": "Notification"
  },
  "notifications.item.openVideo": {
    "defaultMessage": "Voir la vidéo"
  },
  "notifications.item.download": {
    "defaultMessage": "Télécharger"
  },
  "notifications.preferences.category.audit": {
    "defaultMessage": "Audit"
  },
  "notifications.preferences.category.fragments": {
    "defaultMessage": "Fragments"
  },
  "notifications.preferences.category.socialUpload": {
    "defaultMessage": "Réseaux"
  },
  "notifications.preferences.channel.email": {
    "defaultMessage": "E-mail"
  },
  "notifications.preferences.channel.inApp": {
    "defaultMessage": "Dans l’app"
  },
  "notifications.preferences.saveError": {
    "defaultMessage": "Impossible d’enregistrer les préférences"
  },
  "notifications.preferences.title": {
    "defaultMessage": "Préférences de notifications"
  },
  "notifications.preferences.unavailable": {
    "defaultMessage": "Les préférences de notifications ne sont pas disponibles."
  },
  "notifications.preferences.workflow.aodDeficiencyBreached.description": {
    "defaultMessage": "Lorsqu’une exécution AOD n’atteint pas le seuil minimum d’efficacité"
  },
  "notifications.preferences.workflow.aodDeficiencyBreached.title": {
    "defaultMessage": "Efficacité AOD insuffisante"
  },
  "notifications.preferences.workflow.evidenceExportCompleted.description": {
    "defaultMessage": "Lorsque le paquet d’évidences d’un rapport est prêt"
  },
  "notifications.preferences.workflow.evidenceExportCompleted.title": {
    "defaultMessage": "Évidences prêtes à télécharger"
  },
  "notifications.preferences.workflow.socialUploadCompleted.description": {
    "defaultMessage": "Lorsqu’une vidéo est publiée correctement sur un réseau social"
  },
  "notifications.preferences.workflow.socialUploadCompleted.title": {
    "defaultMessage": "Publication réussie"
  },
  "notifications.preferences.workflow.socialUploadFailed.description": {
    "defaultMessage": "Lorsque la publication d’une vidéo sur un réseau social échoue"
  },
  "notifications.preferences.workflow.socialUploadFailed.title": {
    "defaultMessage": "Erreur de publication"
  },
  "notifications.toast.close": {
    "defaultMessage": "Fermer"
  },
  "notifications.toast.story.showAgain": {
    "defaultMessage": "Afficher à nouveau"
  },
  "notifications.toast.viewLink": {
    "defaultMessage": "Voir"
  },
  "notifications.tour.bell.description": {
    "defaultMessage": "Nous centralisons l'état de vos exports, rapports et alertes système. Cliquez sur la cloche pour consulter votre activité récente."
  },
  "notifications.tour.bell.title": {
    "defaultMessage": "Centre de notifications"
  },
  "notifications.tour.demo.aod.body": {
    "defaultMessage": "Une déficience a été détectée dans la campagne planifiée."
  },
  "notifications.tour.demo.aod.title": {
    "defaultMessage": "Déficience AOD : Campagne d'été"
  },
  "notifications.tour.demo.export.title": {
    "defaultMessage": "Export d'evidences prêt"
  },
  "notifications.tour.demo.time.hourAgo": {
    "defaultMessage": "il y a 1 heure"
  },
  "notifications.tour.demo.time.recent": {
    "defaultMessage": "il y a 5 minutes"
  },
  "notifications.tour.demo.time.yesterday": {
    "defaultMessage": "hier"
  },
  "notifications.tour.demo.upload.title": {
    "defaultMessage": "Publication YouTube terminée"
  },
  "notifications.tour.feed.description": {
    "defaultMessage": "Filtrez, lisez ou archivez vos alertes depuis ici. Utilisez l'icône d'engrenage (⚙️) pour personnaliser les avis que vous souhaitez recevoir."
  },
  "notifications.tour.feed.title": {
    "defaultMessage": "Gérez vos notifications"
  },
  "permissions.empty.description": {
    "defaultMessage": "Aucune autorisation disponible."
  },
  "permissions.empty.title": {
    "defaultMessage": "Aucune autorisation trouvée"
  },
  "permissions.error.description": {
    "defaultMessage": "Une erreur s'est produite lors du chargement des autorisations. Veuillez réessayer."
  },
  "permissions.error.title": {
    "defaultMessage": "Erreur lors du chargement des autorisations"
  },
  "playback.rangeWaveformPlayer.noSegments": {
    "defaultMessage": "Aucun audio disponible pour cette plage."
  },
  "search.contactAdmin": {
    "defaultMessage": "Contactez votre administrateur"
  },
  "search.dateTime": {
    "defaultMessage": "Heure"
  },
  "search.featureNotAvailable": {
    "defaultMessage": "Cette fonctionnalité n'est pas disponible pour"
  },
  "search.helpFistLine": {
    "defaultMessage": "Pour les opérations de recherche avancées :"
  },
  "search.helpPlusOp": {
    "defaultMessage": "Le symbole + correspond à l'opérateur logique ET"
  },
  "search.helpVertialBarOp": {
    "defaultMessage": "Le symbole | correspond à l'opérateur logique OU"
  },
  "search.preview": {
    "defaultMessage": "Aperçu"
  },
  "search.title": {
    "defaultMessage": "Rechercher"
  },
  "search.transcription": {
    "defaultMessage": "Transcription"
  },
  "segments.listScreen.futureRange": {
    "defaultMessage": "La plage sélectionnée est dans le futur"
  },
  "segments.listScreen.futureRange.help": {
    "defaultMessage": "Sélectionnez une plage antérieure pour voir l'émission."
  },
  "segments.listScreen.noSegments": {
    "defaultMessage": "Pas d'émission"
  },
  "segments.listScreen.noSegments.help": {
    "defaultMessage": "Essayez de modifier la plage horaire sélectionnée."
  },
  "segments.listScreen.tooRecentRange": {
    "defaultMessage": "La plage est trop récente"
  },
  "segments.listScreen.tooRecentRange.help": {
    "defaultMessage": "Sélectionnez une plage d'au moins {minutes} minutes avant l'heure actuelle."
  },
  "settings.userSettings.form.name.label": {
    "defaultMessage": "Name"
  },
  "settings.userSettings.form.surname.label": {
    "defaultMessage": "Surname"
  },
  "settings.userSettings.title": {
    "defaultMessage": "Paramètres utilisateur"
  },
  "socialExport.connect": {
    "defaultMessage": "Connecter"
  },
  "socialExport.connectAlternatives.dialogTitle": {
    "defaultMessage": "Choisissez comment connecter à {platform}"
  },
  "socialExport.connectAlternatives.permissionsLabel": {
    "defaultMessage": "Autorisations"
  },
  "socialExport.connectAlternatives.recommendedBadge": {
    "defaultMessage": "Recommandé"
  },
  "socialExport.connectAlternatives.redirecting": {
    "defaultMessage": "Redirection vers {platform} pour connecter..."
  },
  "socialExport.connections.accountIdentification": {
    "defaultMessage": "Identification du compte"
  },
  "socialExport.connections.connectedAccounts": {
    "defaultMessage": "Comptes connectés"
  },
  "socialExport.connections.connectedByPrefix": {
    "defaultMessage": "Connecté par"
  },
  "socialExport.connections.customName": {
    "defaultMessage": "Nom personnalisé"
  },
  "socialExport.connections.customNameHelper": {
    "defaultMessage": "Facultatif. Utile s'il y a plus d'une connexion au même profil."
  },
  "socialExport.connections.defaultConnectionName": {
    "defaultMessage": "Par défaut"
  },
  "socialExport.connections.disconnectConfirmDescription": {
    "defaultMessage": "Vous êtes sur le point de déconnecter cette intégration. Êtes-vous sûr ?"
  },
  "socialExport.connections.disconnectWithStationsWarning": {
    "defaultMessage": "Ce compte est lié à {count, plural, one {# station} other {# stations}}. La déconnexion empêchera ces stations de publier avec celui-ci. Êtes-vous sûr ?"
  },
  "socialExport.connections.empty": {
    "defaultMessage": "Aucun compte connecté"
  },
  "socialExport.connections.emptyHelp": {
    "defaultMessage": "Connectez un compte pour commencer à publier sur cette plateforme."
  },
  "socialExport.connections.linkedStationsCount": {
    "defaultMessage": "{count, plural, =0 {Aucune station liée} one {# station liée} other {# stations liées}}"
  },
  "socialExport.connections.noLinkedStations": {
    "defaultMessage": "Aucune station liée pour le moment"
  },
  "socialExport.connections.noneAssignedForStation": {
    "defaultMessage": "Aucun compte connecté n est assigné à cette station pour cette plateforme."
  },
  "socialExport.connections.connectionDetail": {
    "defaultMessage": "Détail"
  },
  "socialExport.connections.selectConnection": {
    "defaultMessage": "Sélectionnez un compte pour voir les détails"
  },
  "socialExport.connections.selectForPublish": {
    "defaultMessage": "Compte de publication"
  },
  "socialExport.connections.selectStations": {
    "defaultMessage": "Stations"
  },
  "socialExport.connections.selectStationsHelper": {
    "defaultMessage": "Seules ces stations pourront publier avec ce compte."
  },
  "socialExport.connections.selectStationsPlaceholder": {
    "defaultMessage": "Sélectionnez une ou plusieurs stations"
  },
  "socialExport.connections.settingsTitle": {
    "defaultMessage": "Configurer {name}"
  },
  "socialExport.connections.stationsPublishingWithAccount": {
    "defaultMessage": "Stations liées"
  },
  "socialExport.connectionSuccess.linkStations": {
    "defaultMessage": "Liez des stations à ce compte et configurez les valeurs par défaut."
  },
  "socialExport.connectionSuccess.title": {
    "defaultMessage": "Connexion réussie avec {name}"
  },
  "socialExport.dailymotion.apiKey": {
    "defaultMessage": "Clé API"
  },
  "socialExport.dailymotion.apiSecret": {
    "defaultMessage": "Secret API"
  },
  "socialExport.dailymotion.channel.animals": {
    "defaultMessage": "Animaux"
  },
  "socialExport.dailymotion.channel.auto": {
    "defaultMessage": "Auto"
  },
  "socialExport.dailymotion.channel.creation": {
    "defaultMessage": "Création"
  },
  "socialExport.dailymotion.channel.fun": {
    "defaultMessage": "Divertissement"
  },
  "socialExport.dailymotion.channel.kids": {
    "defaultMessage": "Enfants"
  },
  "socialExport.dailymotion.channel.lifestyle": {
    "defaultMessage": "Style de vie"
  },
  "socialExport.dailymotion.channel.music": {
    "defaultMessage": "Musique"
  },
  "socialExport.dailymotion.channel.news": {
    "defaultMessage": "Actualités"
  },
  "socialExport.dailymotion.channel.people": {
    "defaultMessage": "Personnes"
  },
  "socialExport.dailymotion.channel.school": {
    "defaultMessage": "École"
  },
  "socialExport.dailymotion.channel.shortfilms": {
    "defaultMessage": "Courts métrages"
  },
  "socialExport.dailymotion.channel.sport": {
    "defaultMessage": "Sport"
  },
  "socialExport.dailymotion.channel.tech": {
    "defaultMessage": "Technologie"
  },
  "socialExport.dailymotion.channel.travel": {
    "defaultMessage": "Voyage"
  },
  "socialExport.dailymotion.channel.tv": {
    "defaultMessage": "TV"
  },
  "socialExport.dailymotion.channel.videogames": {
    "defaultMessage": "Jeux vidéo"
  },
  "socialExport.dailymotion.channel.webcam": {
    "defaultMessage": "Webcam"
  },
  "socialExport.dailymotion.channelId": {
    "defaultMessage": "ID de chaîne"
  },
  "socialExport.dailymotion.channelIdHelper": {
    "defaultMessage": "Identifiant à 7 caractères"
  },
  "socialExport.dailymotion.connect.apiKeyDescription": {
    "defaultMessage": "Saisissez la clé, le secret et l'ID de chaîne depuis Dailymotion Studio. Idéal pour les organisations."
  },
  "socialExport.dailymotion.connect.apiKeyName": {
    "defaultMessage": "Clé API privée"
  },
  "socialExport.dailymotion.connect.loginDescription": {
    "defaultMessage": "Nous vous redirigeons vers Dailymotion pour vous connecter et autoriser l'accès à votre chaîne."
  },
  "socialExport.dailymotion.connect.loginName": {
    "defaultMessage": "Compte Dailymotion"
  },
  "socialExport.dailymotion.connectApiKeyTitle": {
    "defaultMessage": "Connecter Dailymotion via clé API"
  },
  "socialExport.facebook.connect.businessDescription": {
    "defaultMessage": "Publier depuis des comptes Facebook Business"
  },
  "socialExport.facebook.connect.businessName": {
    "defaultMessage": "Facebook Business"
  },
  "socialExport.facebook.connect.businessPermissions": {
    "defaultMessage": "Accès aux pages via Facebook Business. IMPORTANT : lors de l'octroi des autorisations à l'application, donnez accès uniquement à la page sur laquelle vous souhaitez publier."
  },
  "socialExport.facebook.connect.standardDescription": {
    "defaultMessage": "Publier sur des pages Facebook"
  },
  "socialExport.facebook.connect.standardName": {
    "defaultMessage": "Facebook"
  },
  "socialExport.facebook.connect.standardPermissions": {
    "defaultMessage": "Accès aux pages. IMPORTANT : lors de l'octroi des autorisations à l'application, donnez accès uniquement à la page sur laquelle vous souhaitez publier."
  },
  "socialExport.form.category": {
    "defaultMessage": "Catégorie"
  },
  "socialExport.form.commaSeparatedValues": {
    "defaultMessage": "Valeurs séparées par des virgules"
  },
  "socialExport.form.content": {
    "defaultMessage": "Contenu"
  },
  "socialExport.form.defaultValuesUploads": {
    "defaultMessage": "Valeurs par défaut pour les téléchargements"
  },
  "socialExport.form.deleteDelay": {
    "defaultMessage": "Délai de suppression (ms)"
  },
  "socialExport.form.deleteDelayHelper": {
    "defaultMessage": "Délai d'attente avant suppression (0-60000 ms, défaut : 2000)"
  },
  "socialExport.form.demoConfig": {
    "defaultMessage": "Configuration de démo"
  },
  "socialExport.form.demoData": {
    "defaultMessage": "Données de démonstration"
  },
  "socialExport.form.description": {
    "defaultMessage": "Description"
  },
  "socialExport.form.forKids": {
    "defaultMessage": "Contenu adapté aux enfants"
  },
  "socialExport.form.idsSeparatedByComma": {
    "defaultMessage": "IDs séparés par des virgules"
  },
  "socialExport.form.platform": {
    "defaultMessage": "Plateforme"
  },
  "socialExport.form.publishDateLabel": {
    "defaultMessage": "Date et heure de publication"
  },
  "socialExport.form.publishDelay": {
    "defaultMessage": "Délai de publication (ms)"
  },
  "socialExport.form.publishDelayHelper": {
    "defaultMessage": "Délai d'attente avant publication (0-60000 ms, défaut : 10000)"
  },
  "socialExport.form.publishImmediately": {
    "defaultMessage": "Publier immédiatement"
  },
  "socialExport.form.publishToFeed": {
    "defaultMessage": "Publier aussi dans le fil"
  },
  "socialExport.form.replyConfig": {
    "defaultMessage": "Configuration des réponses"
  },
  "socialExport.form.schedule": {
    "defaultMessage": "Planification"
  },
  "socialExport.form.scheduling": {
    "defaultMessage": "Planification"
  },
  "socialExport.form.settings": {
    "defaultMessage": "Paramètres de publication"
  },
  "socialExport.form.shareToFeed": {
    "defaultMessage": "Partager aussi dans le fil"
  },
  "socialExport.form.taggedUsers": {
    "defaultMessage": "Utilisateurs identifiés"
  },
  "socialExport.form.tags": {
    "defaultMessage": "Tags"
  },
  "socialExport.form.thumbnail": {
    "defaultMessage": "Miniature"
  },
  "socialExport.form.thumbnailAndSettings": {
    "defaultMessage": "Miniature et paramètres"
  },
  "socialExport.form.title": {
    "defaultMessage": "Titre"
  },
  "socialExport.form.unsavedChangesLeavePrompt": {
    "defaultMessage": "Êtes-vous sûr de vouloir quitter ? Les modifications non enregistrées seront perdues."
  },
  "socialExport.form.uploadAsPrivate": {
    "defaultMessage": "Télécharger comme vidéo privée"
  },
  "socialExport.history": {
    "defaultMessage": "Historique"
  },
  "socialExport.manage.configure": {
    "defaultMessage": "Configurer"
  },
  "socialExport.manage.disconnect": {
    "defaultMessage": "Déconnecter"
  },
  "socialExport.mediaLimits.blocked": {
    "defaultMessage": "La vidéo dépasse la durée maximale autorisée par la plateforme."
  },
  "socialExport.mediaLimits.blockedWithMax": {
    "defaultMessage": "La vidéo dépasse la durée maximale autorisée par la plateforme ({maxMinutes} min)."
  },
  "socialExport.mediaLimits.needsTranscoding": {
    "defaultMessage": "La taille de la vidéo dépasse la limite de la plateforme ; elle sera réduite à {quality}p pour pouvoir être publiée."
  },
  "socialExport.mediaLimits.platformDisplaysLower": {
    "defaultMessage": "{platformName} l'affichera jusqu'à {quality}p."
  },
  "socialExport.publish.chip.cancelled": {
    "defaultMessage": "Annulé"
  },
  "socialExport.publish.chip.error": {
    "defaultMessage": "Erreur"
  },
  "socialExport.publish.chip.errorCode": {
    "defaultMessage": "Code : {errorCode}"
  },
  "socialExport.publish.chip.inProgress": {
    "defaultMessage": "En cours"
  },
  "socialExport.publish.chip.published": {
    "defaultMessage": "Publié"
  },
  "socialExport.publish.chip.scheduled": {
    "defaultMessage": "Programmé"
  },
  "socialExport.publish.chip.waitingForMedia": {
    "defaultMessage": "En attente du média"
  },
  "socialExport.publish.connectionNotReady": {
    "defaultMessage": "La connexion au réseau social est encore en cours de chargement ; réessaie dans un instant."
  },
  "socialExport.publish.createdBy": {
    "defaultMessage": "Créé par {user}"
  },
  "socialExport.publish.deleteFromPlatform": {
    "defaultMessage": "Supprimer de {platform}"
  },
  "socialExport.publish.deleteScheduledPublishMessage": {
    "defaultMessage": "Êtes-vous sûr de vouloir supprimer cette publication programmée ? Cette action est irréversible."
  },
  "socialExport.publish.deleteScheduledPublishTitle": {
    "defaultMessage": "Supprimer la publication programmée"
  },
  "socialExport.publish.deleteVideoFromPlatformMessage": {
    "defaultMessage": "Êtes-vous sûr de vouloir supprimer cette vidéo de la plateforme ? Cette action est irréversible."
  },
  "socialExport.publish.deleteVideoFromPlatformTitle": {
    "defaultMessage": "Supprimer la vidéo de {platform}"
  },
  "socialExport.publish.editionWithName": {
    "defaultMessage": "Edit: {name}"
  },
  "socialExport.publish.error.youtubeReconnectRequired": {
    "defaultMessage": "Les identifiants YouTube sont obsolètes. Il faut reconnecter le compte."
  },
  "socialExport.publish.errorDeletingPublication": {
    "defaultMessage": "Une erreur s'est produite lors de la suppression de la publication"
  },
  "socialExport.publish.errorDeletingVideo": {
    "defaultMessage": "Une erreur s'est produite lors de la suppression de la vidéo"
  },
  "socialExport.publish.errorPublishingNow": {
    "defaultMessage": "Une erreur s'est produite lors de la publication immédiate"
  },
  "socialExport.publish.forKidsDescription": {
    "defaultMessage": "Les restrictions de la plateforme pour les contenus destinés aux enfants s'appliquent."
  },
  "socialExport.publish.manageVideo": {
    "defaultMessage": "Gérer la vidéo sur {platform}"
  },
  "socialExport.publish.mediaSelector.edition": {
    "defaultMessage": "Edit"
  },
  "socialExport.publish.mediaSelector.label": {
    "defaultMessage": "Vidéo à publier"
  },
  "socialExport.publish.mediaSelector.originalMedia": {
    "defaultMessage": "Média original"
  },
  "socialExport.publish.mediaSelector.renderNotReadyComposition": {
    "defaultMessage": "La vidéo de ce montage n'est pas encore générée. Générez-la depuis l'onglet Montages."
  },
  "socialExport.publish.mediaSelector.renderNotReadyFragment": {
    "defaultMessage": "La vidéo de cet edit n'a pas encore été générée. Générez-la depuis l'onglet edits."
  },
  "socialExport.publish.noAdditionalActions": {
    "defaultMessage": "La plateforme ne permet aucune action supplémentaire"
  },
  "socialExport.publish.noAllowedSourceError": {
    "defaultMessage": "Aucune source n'est disponible pour publier sur cette station."
  },
  "socialExport.publish.noOAuthConnectionForPlatform": {
    "defaultMessage": "{platformName} n'est pas connecté pour cette station."
  },
  "socialExport.publish.noPlatformsToPublish": {
    "defaultMessage": "Aucune plateforme pour publier"
  },
  "socialExport.publish.noRenderedEdit": {
    "defaultMessage": "Aucun montage avec une vidéo générée à publier."
  },
  "socialExport.publish.noStation": {
    "defaultMessage": "Cette composition n'a pas de station assignée."
  },
  "socialExport.publish.panorama.goToEdits": {
    "defaultMessage": "Aller aux edits"
  },
  "socialExport.publish.panorama.noConnectedPlatforms": {
    "defaultMessage": "Aucune plateforme connectée pour publier."
  },
  "socialExport.publish.panorama.noSourcesComposition": {
    "defaultMessage": "Pour publier sur les réseaux sociaux, vous devez générer une vidéo à partir d'un montage vidéo."
  },
  "socialExport.publish.panorama.noSourcesFragment": {
    "defaultMessage": "Pour publier sur les réseaux sociaux, il est nécessaire de générer une vidéo à partir du fragment."
  },
  "socialExport.publish.panorama.notPublishedComposition": {
    "defaultMessage": "Vous n'avez pas encore publié cette composition sur les réseaux sociaux."
  },
  "socialExport.publish.panorama.notPublishedFragment": {
    "defaultMessage": "Vous n'avez pas encore publié ce fragment sur les réseaux sociaux."
  },
  "socialExport.publish.platformSwitcherLabel": {
    "defaultMessage": "Plateforme"
  },
  "socialExport.publish.postPublishProcessingNotice": {
    "defaultMessage": "Après avoir publié, le contenu peut prendre quelques minutes à être traité et visible sur votre profil."
  },
  "socialExport.publish.publicationDeleted": {
    "defaultMessage": "Publication supprimée"
  },
  "socialExport.publish.publicationsSectionTitle": {
    "defaultMessage": "Publications ({count})"
  },
  "socialExport.publish.publicationStarted": {
    "defaultMessage": "Publication démarrée"
  },
  "socialExport.publish.publishedOn": {
    "defaultMessage": "Publié le :"
  },
  "socialExport.publish.publishImmediatelyDescription": {
    "defaultMessage": "Désactiver pour choisir une date et une heure de publication future"
  },
  "socialExport.publish.publishNow": {
    "defaultMessage": "Publier maintenant"
  },
  "socialExport.publish.publishNowConfirmMessage": {
    "defaultMessage": "Êtes-vous sûr de vouloir publier cette vidéo maintenant au lieu d'attendre la date programmée ?"
  },
  "socialExport.publish.publishNowConfirmTitle": {
    "defaultMessage": "Publier maintenant"
  },
  "socialExport.publish.publishTo": {
    "defaultMessage": "Publier sur"
  },
  "socialExport.publish.publishToSectionTitle": {
    "defaultMessage": "Publier sur"
  },
  "socialExport.publish.publishToSocialNetworks": {
    "defaultMessage": "Publier sur les réseaux sociaux"
  },
  "socialExport.publish.retry": {
    "defaultMessage": "Réessayer"
  },
  "socialExport.publish.scheduledAlertTitle": {
    "defaultMessage": "Publication programmée"
  },
  "socialExport.publish.sectionTitle": {
    "defaultMessage": "Réseaux sociaux"
  },
  "socialExport.publish.sendToPlatform": {
    "defaultMessage": "Publier sur {platformName}"
  },
  "socialExport.publish.shareToFeedDescription": {
    "defaultMessage": "En plus du reel, la publication apparaîtra dans le fil principal du compte."
  },
  "socialExport.publish.startPublicationError": {
    "defaultMessage": "Ocurrió un error al iniciar la publicación, contacte a soporte"
  },
  "socialExport.publish.uploadAsPrivateDescription": {
    "defaultMessage": "La vidéo reste visible uniquement sur le compte jusqu'à ce qu'elle soit publiée publiquement"
  },
  "socialExport.publish.uploadDetail.publishedTitle": {
    "defaultMessage": "Publié"
  },
  "socialExport.publish.videoDeletedFromPlatform": {
    "defaultMessage": "Vidéo supprimée de la plateforme"
  },
  "socialExport.publish.videoPreview.title": {
    "defaultMessage": "Aperçu de la vidéo"
  },
  "socialExport.publish.videoWillPublishAt": {
    "defaultMessage": "La vidéo sera publiée le :"
  },
  "socialExport.publish.viewVideo": {
    "defaultMessage": "Voir la vidéo"
  },
  "socialExport.publish.waitingPublicLink": {
    "defaultMessage": "En attente du lien public"
  },
  "socialExport.select.none": {
    "defaultMessage": "Aucun"
  },
  "socialExport.settings.updated": {
    "defaultMessage": "Configuration mise à jour avec succès"
  },
  "socialExport.rudo.accessToken": {
    "defaultMessage": "Access token"
  },
  "socialExport.rudo.accessTokenHelper": {
    "defaultMessage": "Jeton statique de votre compte Rudo.video"
  },
  "socialExport.rudo.connectApiKeyTitle": {
    "defaultMessage": "Connecter Rudo avec un access token"
  },
  "socialExport.rudo.displayName": {
    "defaultMessage": "Nom d'affichage"
  },
  "socialExport.rudo.displayNameHelper": {
    "defaultMessage": "Facultatif. Utile si vous connectez plus d'un compte Rudo."
  },
  "socialExport.rudo.folder.create": {
    "defaultMessage": "Créer un dossier"
  },
  "socialExport.rudo.folder.createCancel": {
    "defaultMessage": "Annuler"
  },
  "socialExport.rudo.folder.createSubmit": {
    "defaultMessage": "Créer"
  },
  "socialExport.rudo.folder.createSuccess": {
    "defaultMessage": "Dossier créé"
  },
  "socialExport.rudo.folder.createTitle": {
    "defaultMessage": "Nouveau dossier"
  },
  "socialExport.rudo.folder.helper": {
    "defaultMessage": "Dossier de destination sur Rudo"
  },
  "socialExport.rudo.folder.label": {
    "defaultMessage": "Dossier"
  },
  "socialExport.rudo.folder.name": {
    "defaultMessage": "Nom du dossier"
  },
  "socialExport.rudo.folder.noOptions": {
    "defaultMessage": "Aucun dossier disponible"
  },
  "socialExport.rudo.restriction.label": {
    "defaultMessage": "Restriction VOD"
  },
  "socialExport.rudo.restriction.none": {
    "defaultMessage": "Sans restriction"
  },
  "socialExport.rudo.restriction.premium": {
    "defaultMessage": "Premium"
  },
  "socialExport.rudo.restriction.registration": {
    "defaultMessage": "Utilisateurs enregistrés uniquement"
  },
  "socialExport.tiktok.disclosure.brandedContent.description": {
    "defaultMessage": "Vous promeuvez une autre marque ou un tiers. Cette vidéo sera classée comme contenu de marque."
  },
  "socialExport.tiktok.disclosure.brandedContent.label": {
    "defaultMessage": "Contenu de marque"
  },
  "socialExport.tiktok.disclosure.brandedContentAndMusicAgree": {
    "defaultMessage": "En publiant, vous acceptez la {brandedContentLink} et la {musicLink} de TikTok."
  },
  "socialExport.tiktok.disclosure.brandedContentPolicyLink": {
    "defaultMessage": "Politique relative au contenu de marque"
  },
  "socialExport.tiktok.disclosure.brandedContentVisibilityCannotBePrivate": {
    "defaultMessage": "La confidentialité du contenu promotionnel d'une autre marque ne peut pas être « Moi uniquement »."
  },
  "socialExport.tiktok.disclosure.brandedContentVisibilityTooltip": {
    "defaultMessage": "La visibilité du contenu de marque ne peut pas être définie sur privé."
  },
  "socialExport.tiktok.disclosure.description": {
    "defaultMessage": "Activez pour indiquer que cette vidéo promeut des biens ou services en échange d'une contrepartie. Votre vidéo peut vous promouvoir, un tiers ou les deux."
  },
  "socialExport.tiktok.disclosure.labelPaidPartnership": {
    "defaultMessage": "Votre vidéo sera étiquetée « Partenariat rémunéré »."
  },
  "socialExport.tiktok.disclosure.labelPaidPartnershipAlert": {
    "defaultMessage": "Votre vidéo sera étiquetée « Partenariat rémunéré ». Cela ne peut pas être modifié après publication."
  },
  "socialExport.tiktok.disclosure.labelPromotionalContent": {
    "defaultMessage": "Votre vidéo sera étiquetée « Contenu promotionnel »."
  },
  "socialExport.tiktok.disclosure.musicUsageAgree": {
    "defaultMessage": "En publiant, vous acceptez notre {link}."
  },
  "socialExport.tiktok.disclosure.musicUsageConfirmationLink": {
    "defaultMessage": "Confirmation d'utilisation de la musique"
  },
  "socialExport.tiktok.disclosure.promotionalLabel": {
    "defaultMessage": "Votre vidéo sera étiquetée « Contenu promotionnel ». Cela ne peut pas être modifié après publication."
  },
  "socialExport.tiktok.disclosure.selectAtLeastOneHint": {
    "defaultMessage": "Vous devez indiquer si votre contenu vous promeut, un tiers ou les deux."
  },
  "socialExport.tiktok.disclosure.toggle": {
    "defaultMessage": "Déclarer le contenu vidéo"
  },
  "socialExport.tiktok.disclosure.yourBrand.description": {
    "defaultMessage": "Vous promeuvez vous-même ou votre entreprise. Cette vidéo sera classée comme Brand Organic."
  },
  "socialExport.tiktok.disclosure.yourBrand.label": {
    "defaultMessage": "Votre marque"
  },
  "socialExport.tiktok.privacy.followers": {
    "defaultMessage": "Abonnés"
  },
  "socialExport.tiktok.privacy.friends": {
    "defaultMessage": "Amis"
  },
  "socialExport.tiktok.privacy.public": {
    "defaultMessage": "Public"
  },
  "socialExport.tiktok.privacy.self": {
    "defaultMessage": "Moi uniquement"
  },
  "socialExport.tiktok.settings.allowComment": {
    "defaultMessage": "Commenter"
  },
  "socialExport.tiktok.settings.allowDuet": {
    "defaultMessage": "Duo"
  },
  "socialExport.tiktok.settings.allowStitch": {
    "defaultMessage": "Stitch"
  },
  "socialExport.tiktok.settings.allowUsersTo": {
    "defaultMessage": "Permettre aux utilisateurs "
  },
  "socialExport.tiktok.settings.disabledByTiktokPrivacyTooltip": {
    "defaultMessage": "Désactivé dans les paramètres de confidentialité de ton compte TikTok."
  },
  "socialExport.tiktok.settings.privacyLabel": {
    "defaultMessage": "Confidentialité"
  },
  "socialExport.twitter.replyEveryone": {
    "defaultMessage": "Tout le monde"
  },
  "socialExport.twitter.replyFollowing": {
    "defaultMessage": "Personnes que vous suivez"
  },
  "socialExport.twitter.replyMentioned": {
    "defaultMessage": "Utilisateurs mentionnés"
  },
  "socialExport.twitter.replySubscribers": {
    "defaultMessage": "Abonnés"
  },
  "socialExport.twitter.replyVerified": {
    "defaultMessage": "Vérifié"
  },
  "socialExport.uploaded.columnFragment": {
    "defaultMessage": "Fragment"
  },
  "socialExport.uploaded.columnPublished": {
    "defaultMessage": "Publié"
  },
  "socialExport.uploaded.columnStation": {
    "defaultMessage": "Station"
  },
  "socialExport.uploaded.columnStatus": {
    "defaultMessage": "Statut"
  },
  "socialExport.uploaded.linkLabel": {
    "defaultMessage": "Vidéos publiées"
  },
  "socialExport.uploaded.title": {
    "defaultMessage": "Vidéos récemment publiées"
  },
  "socialExport.youtube.category": {
    "defaultMessage": "Catégorie"
  },
  "socialExport.youtube.connect.advancedDescription": {
    "defaultMessage": "Gérer les playlists et supprimer des vidéos"
  },
  "socialExport.youtube.connect.advancedName": {
    "defaultMessage": "Mode avancé"
  },
  "socialExport.youtube.connect.advancedPermissions": {
    "defaultMessage": "Publier des vidéos, les ajouter aux playlists et les supprimer"
  },
  "socialExport.youtube.connect.basicDescription": {
    "defaultMessage": "Publier des vidéos sans gérer les playlists ni supprimer"
  },
  "socialExport.youtube.connect.basicName": {
    "defaultMessage": "Mode basique"
  },
  "socialExport.youtube.connect.basicPermissions": {
    "defaultMessage": "Publier des vidéos uniquement"
  },
  "socialExport.youtube.idealSize": {
    "defaultMessage": "Taille idéale : 1280 x 720 px"
  },
  "socialExport.youtube.madeForKids": {
    "defaultMessage": "Contenu adapté aux enfants"
  },
  "socialExport.youtube.playlist.helperText": {
    "defaultMessage": "Sélectionnez une ou plusieurs playlists"
  },
  "socialExport.youtube.playlist.label": {
    "defaultMessage": "Playlists"
  },
  "socialExport.youtube.playlist.noManagePermissions": {
    "defaultMessage": "La connexion actuelle n'a pas les autorisations pour gérer les playlists. Il faut se reconnecter pour accorder ces autorisations."
  },
  "socialExport.youtube.playlist.noOptions": {
    "defaultMessage": "Aucune playlist disponible"
  },
  "socialExport.youtube.playlist.notFound": {
    "defaultMessage": "Playlist introuvable ?"
  },
  "socialExport.youtube.playlist.privacyStatus.private": {
    "defaultMessage": "Privée"
  },
  "socialExport.youtube.playlist.privacyStatus.public": {
    "defaultMessage": "Publique"
  },
  "socialExport.youtube.playlist.privacyStatus.unlisted": {
    "defaultMessage": "Non répertoriée"
  },
  "socialExport.youtube.playlist.refresh": {
    "defaultMessage": "Actualiser la liste"
  },
  "socialExport.youtube.playlist.videoCount": {
    "defaultMessage": "{count, plural, one {# vidéo} other {# vidéos}}"
  },
  "stationConfig.noPrompts": {
    "defaultMessage": "Aucune invite enregistrée"
  },
  "stations.noVideoStations": {
    "defaultMessage": "Aucune station vidéo enregistrée"
  },
  "stations.selector.favorites": {
    "defaultMessage": "Favoris"
  },
  "stations.selector.myStations": {
    "defaultMessage": "Mes stations"
  },
  "stations.selector.recent": {
    "defaultMessage": "Récent"
  },
  "stations.selector.removeRecent": {
    "defaultMessage": "Retirer des récents"
  },
  "stations.selector.shared": {
    "defaultMessage": "Stations externes"
  },
  "stations.selector.sharedGroup": {
    "defaultMessage": "{name}"
  },
  "streamBox.device.coords": {
    "defaultMessage": "(Lat. {lat}, Long. {lng})"
  },
  "streamBox.listScreen.manageBtn": {
    "defaultMessage": "Manage device"
  },
  "streamBox.listScreen.noDevices": {
    "defaultMessage": "No devices found"
  },
  "streamBox.listScreen.title": {
    "defaultMessage": "StreamBox devices"
  },
  "streamBox.nav.title": {
    "defaultMessage": "Stream Box"
  },
  "streamBox.props.device": {
    "defaultMessage": "Device"
  },
  "streamBox.props.id": {
    "defaultMessage": "ID"
  },
  "streamBox.props.location": {
    "defaultMessage": "Location"
  },
  "streamBox.props.service": {
    "defaultMessage": "Service"
  },
  "streamBox.props.services": {
    "defaultMessage": "Services"
  },
  "streamBox.props.status": {
    "defaultMessage": "Status"
  },
  "streamBox.viewScreen.actions.reboot.btn": {
    "defaultMessage": "Reboot"
  },
  "streamBox.viewScreen.actions.reboot.confirm": {
    "defaultMessage": "Do you really wish to restart the device?"
  },
  "streamBox.viewScreen.actions.reboot.done": {
    "defaultMessage": "Device reboot requested"
  },
  "streamBox.viewScreen.actions.rename.btn": {
    "defaultMessage": "Rename"
  },
  "streamBox.viewScreen.actions.rename.done": {
    "defaultMessage": "Device renamed"
  },
  "streamBox.viewScreen.actions.rename.label": {
    "defaultMessage": "New name"
  },
  "streamBox.viewScreen.actions.rename.title": {
    "defaultMessage": "Rename device"
  },
  "streamBox.viewScreen.actions.setCoords.button": {
    "defaultMessage": "Définir les coordonnées"
  },
  "streamBox.viewScreen.actions.setCoords.done": {
    "defaultMessage": "Coordonnées mises à jour"
  },
  "streamBox.viewScreen.actions.setCoords.latitude": {
    "defaultMessage": "Latitude"
  },
  "streamBox.viewScreen.actions.setCoords.longitude": {
    "defaultMessage": "Longitude"
  },
  "streamBox.viewScreen.actions.setCoords.title": {
    "defaultMessage": "Set coordinates"
  },
  "streamBox.viewScreen.clickLocation": {
    "defaultMessage": "Click to show location on map"
  },
  "streamBox.viewScreen.loading": {
    "defaultMessage": "Loading device"
  },
  "streamBox.viewScreen.services.actions.config.btn": {
    "defaultMessage": "Config"
  },
  "streamBox.viewScreen.services.actions.config.title": {
    "defaultMessage": "Configure service"
  },
  "streamBox.viewScreen.services.actions.restart.btn": {
    "defaultMessage": "Restart"
  },
  "streamBox.viewScreen.services.actions.restart.done": {
    "defaultMessage": "Service restart requested"
  },
  "streamBox.viewScreen.services.actions.restart.error": {
    "defaultMessage": "Could not restart service"
  },
  "streamBox.viewScreen.services.actions.restart.prompt": {
    "defaultMessage": "Do you really wish to restart the service?"
  },
  "streamBox.viewScreen.services.actions.start.btn": {
    "defaultMessage": "Start"
  },
  "streamBox.viewScreen.services.actions.start.done": {
    "defaultMessage": "Service start requested"
  },
  "streamBox.viewScreen.services.actions.start.error": {
    "defaultMessage": "Could not start service"
  },
  "streamBox.viewScreen.services.actions.start.prompt": {
    "defaultMessage": "Do you really wish to start the service?"
  },
  "streamBox.viewScreen.services.actions.stop.btn": {
    "defaultMessage": "Stop"
  },
  "streamBox.viewScreen.services.actions.stop.done": {
    "defaultMessage": "Service stop requested"
  },
  "streamBox.viewScreen.services.actions.stop.error": {
    "defaultMessage": "Could not stop service"
  },
  "streamBox.viewScreen.services.actions.stop.prompt": {
    "defaultMessage": "Do you really wish to stop the service?"
  },
  "streamBox.viewScreen.services.config.done": {
    "defaultMessage": "Service config updated"
  },
  "streamBox.viewScreen.services.config.error": {
    "defaultMessage": "Could not update service config"
  },
  "streamBox.viewScreen.services.config.noVars": {
    "defaultMessage": "There are no available variables for this service"
  },
  "streamBox.viewScreen.title": {
    "defaultMessage": "Device {deviceName} / StreamBox"
  },
  "tagGroups.defaultGroup": {
    "defaultMessage": "Groupe par défaut"
  },
  "tagGroups.groupName": {
    "defaultMessage": "Nom du groupe"
  },
  "tagGroups.tags": {
    "defaultMessage": "Tags"
  },
  "tagGroups.tagsPlaceholder": {
    "defaultMessage": "Tapez et appuyez sur Entrée/virgule pour ajouter des tags"
  },
  "tours.driver.done": {
    "defaultMessage": "Terminé"
  },
  "tours.driver.new": {
    "defaultMessage": "Nouveau"
  },
  "tours.driver.next": {
    "defaultMessage": "Suivant"
  },
  "tours.driver.previous": {
    "defaultMessage": "Précédent"
  },
  "tours.driver.progress": {
    "defaultMessage": "{current} sur {total}"
  },
  "ui.copyUrlButton.copyLink": {
    "defaultMessage": "Copier le lien à partager"
  },
  "ui.stationsFilter.label": {
    "defaultMessage": "Filtre des stations"
  },
  "ui.stationsFilter.optionType.long.individualStation": {
    "defaultMessage": "Station individuelle"
  },
  "ui.stationsFilter.optionType.long.stationGroup": {
    "defaultMessage": "Groupe de stations"
  },
  "ui.stationsFilter.optionType.long.stationType": {
    "defaultMessage": "Type de station"
  },
  "ui.stationsFilter.optionType.short.individualStation": {
    "defaultMessage": "Station"
  },
  "ui.stationsFilter.optionType.short.stationGroup": {
    "defaultMessage": "Groupe"
  },
  "ui.stationsFilter.optionType.short.stationType": {
    "defaultMessage": "Type"
  },
  "ui.stationsFilter.placeholder": {
    "defaultMessage": "Sélectionner une ou plusieurs options"
  },
  "ui.stationsSelector.enterToGo": {
    "defaultMessage": "Entrée pour aller"
  },
  "ui.stationsSelector.searchPlaceholder": {
    "defaultMessage": "Rechercher une station"
  },
  "ui.versionChecker.appUpToDate": {
    "defaultMessage": "L'app est à jour ({version})"
  },
  "ui.versionChecker.newVersionAvailable": {
    "defaultMessage": "Une nouvelle version de l'app est disponible"
  },
  "ui.versionChecker.newVersionAvailableExpand": {
    "defaultMessage": "Nouvelle version disponible, cliquer pour développer"
  },
  "ui.versionChecker.newVersionAvailableReload": {
    "defaultMessage": "Nouvelle version disponible, cliquer pour mettre à jour"
  },
  "ui.versionChecker.update": {
    "defaultMessage": "Mettre à jour"
  },
  "userPermission.inheritsFromGroup": {
    "defaultMessage": "Hérite du groupe"
  },
  "users.chipList.unknownUser": {
    "defaultMessage": "Utilisateur inconnu"
  },
  "validateUpload.fileLabel": {
    "defaultMessage": "Fichier :"
  },
  "validateUpload.itemsCreated": {
    "defaultMessage": "{count} éléments créés"
  },
  "validateUpload.process": {
    "defaultMessage": "Traiter"
  },
  "validateUpload.processNewFile": {
    "defaultMessage": "Traiter un nouveau fichier"
  },
  "validateUpload.tryAgain": {
    "defaultMessage": "Réessayer"
  },
  "validateUpload.verifyError": {
    "defaultMessage": "Une erreur s'est produite lors de la vérification du fichier"
  },
  "validation.maxValue60000": {
    "defaultMessage": "Doit être inférieur ou égal à 60000"
  },
  "validation.minValueZero": {
    "defaultMessage": "Doit être supérieur ou égal à 0"
  },
  "videoEditions.autoEditName": {
    "defaultMessage": "Edit {n}"
  },
  "videoEditions.category.draftChip": {
    "defaultMessage": "Brouillons et en cours ({count})"
  },
  "videoEditions.category.generatedChip": {
    "defaultMessage": "Générés ({count})"
  },
  "videoEditions.clone": {
    "defaultMessage": "Cloner l'edit"
  },
  "videoEditions.cloneDialog.nameLabel": {
    "defaultMessage": "Nom"
  },
  "videoEditions.cloneDialog.submit": {
    "defaultMessage": "Cloner"
  },
  "videoEditions.cloneDialog.title": {
    "defaultMessage": "Cloner l'edit"
  },
  "videoEditions.createEdit": {
    "defaultMessage": "Créer un edit"
  },
  "videoEditions.deleteConfirm": {
    "defaultMessage": "Supprimer cet edit ? Cette action est irréversible."
  },
  "videoEditions.editCard.publishedOn": {
    "defaultMessage": "Publié sur"
  },
  "videoEditions.emptyDraftTab": {
    "defaultMessage": "Aucun brouillon ni rendu en cours dans cette section"
  },
  "videoEditions.emptyGeneratedTab": {
    "defaultMessage": "Pas encore de vidéos générées"
  },
  "videoEditions.emptyHelp": {
    "defaultMessage": "Pas encore d'edits"
  },
  "videoEditions.finishedOn": {
    "defaultMessage": "Généré"
  },
  "videoEditions.status.generated": {
    "defaultMessage": "Prêt à publier"
  },
  "videoEditions.status.notGenerated": {
    "defaultMessage": "Non généré"
  },
  "videoEditions.tabTitle": {
    "defaultMessage": "edits"
  },
  "youtube.cuepoints.column.createdAt": {
    "defaultMessage": "Date/heure d'insertion"
  },
  "youtube.cuepoints.column.cuepointId": {
    "defaultMessage": "ID du cuepoint"
  },
  "youtube.cuepoints.column.videoId": {
    "defaultMessage": "ID vidéo"
  },
  "youtube.cuepoints.insert.button": {
    "defaultMessage": "Insérer un cuepoint"
  },
  "youtube.cuepoints.insert.dialogTitle": {
    "defaultMessage": "Insérer un cuepoint manuellement"
  },
  "youtube.cuepoints.insert.durationHelper": {
    "defaultMessage": "Entre 1 et 300 secondes"
  },
  "youtube.cuepoints.insert.durationLabel": {
    "defaultMessage": "Durée (secondes)"
  },
  "youtube.cuepoints.insert.durationMax": {
    "defaultMessage": "La durée maximale est de 300 secondes"
  },
  "youtube.cuepoints.insert.durationMin": {
    "defaultMessage": "La durée minimale est de 1 seconde"
  },
  "youtube.cuepoints.insert.durationRequired": {
    "defaultMessage": "La durée est obligatoire"
  },
  "youtube.cuepoints.insert.error": {
    "defaultMessage": "Impossible d'insérer le cuepoint"
  },
  "youtube.cuepoints.insert.submit": {
    "defaultMessage": "Insérer"
  },
  "youtube.cuepoints.insert.success": {
    "defaultMessage": "Cuepoint inséré avec succès"
  },
  "youtube.cuepoints.manageCuepoints": {
    "defaultMessage": "Voir les cuepoints enregistrés"
  },
  "youtube.cuepoints.manageCuepointsAlertTitle": {
    "defaultMessage": "Cuepoints YouTube"
  },
  "youtube.cuepoints.pageTitle": {
    "defaultMessage": "Cuepoints"
  },
  "youtube.privacyStatus.label": {
    "defaultMessage": "Statut de confidentialité"
  },
  "youtube.privacyStatus.private": {
    "defaultMessage": "Privé"
  },
  "youtube.privacyStatus.public": {
    "defaultMessage": "Public"
  },
  "youtube.privacyStatus.unlisted": {
    "defaultMessage": "Non répertorié"
  }
}
